"use strict";
var NotifyType;
(function (NotifyType) {
    NotifyType["Info"] = "info";
    NotifyType["Warning"] = "warning";
    NotifyType["Success"] = "success";
    NotifyType["Error"] = "error";
})(NotifyType || (NotifyType = {}));
class AppEnums {
}
AppEnums.titles = {
    oeWinTitle: "Open Enrollment",
    getPinTitile: "Get PIN or Reset Password"
};
AppEnums.readOnly = {
    Yes: true,
    No: false
};
var appEnums = new AppEnums();
var AppFunc;
(function (AppFunc) {
    function describeError(e) {
        if (typeof e === "string") {
            return e;
        }
        return `${e?.errorThrown} | Status:${e?.status} | ${e?.xhr?.statusText} | ${e?.xhr?.responseText}`;
    }
    class SharedFunc {
        constructor() {
            this.logEventError = (e, status) => {
                this.logJavaScriptError(describeError(e), true);
            };
            this.logDataSourceError = (e, status) => {
                this.logJavaScriptError(`${e?.sender?.transport?.options?.read?.url} | ${describeError(e)}`, true);
            };
        }
        strConcat(s1 = "", s2 = "", s3 = "") {
            return `${s1}${s2}${s3}`;
        }
        progressShow() {
            if ($("#image_loading").length && $("#image_loading").data("kendoLoader")) {
                $("#image_loading").data("kendoLoader").show();
            }
            $(".progressIndWin").show();
        }
        progressHide() {
            if ($("#image_loading").length && $("#image_loading").data("kendoLoader")) {
                $("#image_loading").data("kendoLoader").hide();
            }
            $(".progressIndWin").hide();
        }
        logJavaScriptError(errorMessage, silentLog) {
            const urlPath = window.location.href;
            errorMessage = errorMessage + " | \n" + urlPath;
            $.ajax({
                url: "/Home/LogJavaScriptError",
                type: "POST",
                global: false,
                cache: false,
                data: {
                    __RequestVerificationToken: $("input[name=__RequestVerificationToken]").val(),
                    message: errorMessage
                }
            });
            if (silentLog)
                return;
            const errorMsg = "We are sorry an unexpected error occurred!<br />A log of the error has been created and sent to the system administrator";
            if (kendoWin.openInfoWin) {
                kendoWin.openInfoWin("An error occurred", errorMsg);
            }
            else {
                alert(errorMsg.replace("<br />", "\n"));
            }
        }
        replaceHtml(selector, html) {
            const target = $(selector);
            kendo.destroy(target);
            target.html(html);
        }
        getVerificationToken() {
            return $("input[name=__RequestVerificationToken]").val();
        }
        includeAntiForgeryToken() {
            var verificationToken = $("input[name=__RequestVerificationToken]").val();
            return { "__RequestVerificationToken": verificationToken };
        }
        downloadFile(uri) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", uri, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
                if (this.status !== 200) {
                    appFunc.logJavaScriptError(`Download failed - HTTP ${this.status} - ${uri}`, true);
                    kendoWin.openInfoWin("Alert", "An error occurred during the download!");
                    return;
                }
                var contentType = this.getResponseHeader("content-type");
                var contentDisposition = this.getResponseHeader("Content-Disposition");
                if (contentDisposition == null && contentType === "text/html") {
                    kendoWin.openInfoWin("Alert", "This document is no longer available!");
                    return;
                }
                var blob = this.response;
                var filename = appFunc.getFilenameFromHeaders(this) || uri.split("/").pop() || "download";
                var downloadLink = document.createElement("a");
                var url = window.URL.createObjectURL(blob);
                downloadLink.href = url;
                downloadLink.download = filename;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                setTimeout(function () {
                    window.URL.revokeObjectURL(url);
                }, 100);
            };
            xhr.onerror = function () {
                appFunc.logJavaScriptError(`Download network error - ${uri}`, true);
                kendoWin.openInfoWin("Alert", "A network error occurred during the download!");
            };
            xhr.send();
        }
        getFilenameFromHeaders(xhr) {
            const contentDisposition = xhr.getResponseHeader("Content-Disposition");
            if (!contentDisposition)
                return null;
            const encoded = contentDisposition.match(/filename\*\s*=\s*[^']*'[^']*'([^;\n]*)/i);
            if (encoded != null && encoded[1]) {
                try {
                    return decodeURIComponent(encoded[1].trim());
                }
                catch {
                }
            }
            const plain = contentDisposition.match(/filename\s*=\s*(?:"([^"]*)"|([^;\n]*))/i);
            if (plain != null) {
                return (plain[1] ?? plain[2]).trim();
            }
            return null;
        }
        hideWhenEmpty(elementToWatch, elementToHide) {
            $(`${elementToWatch}`).on("input", () => {
                if ($(`${elementToWatch}`).val().trim().length > 0) {
                    $(`${elementToHide}`).show();
                }
                else {
                    $(`${elementToHide}`).hide();
                }
            });
        }
        setFocus(elementId) {
            if (!elementId)
                return;
            if (elementId.charAt(0) !== "#")
                elementId = `#${elementId}`;
            if ($(elementId).length && $(elementId).is(":visible")) {
                setTimeout(() => {
                    $(elementId).focus();
                }, 100);
            }
        }
        showTermsInfo() {
            kendoWin.openMainWin("Service Terms", "/home/ServiceTerms", null, 800);
        }
        showPolicyInfo() {
            kendoWin.openMainWin("Privacy Policy", "/home/PrivacyPolicy", null, 800);
        }
        windowResized() {
            kendoWin.deviceResized();
        }
        outputPrint(title, container) {
            if (container.charAt(0) !== "#")
                container = `#${container}`;
            const contents = $(container).html();
            const printIframe = document.getElementById('print_iframe');
            printIframe.contentWindow.postMessage(JSON.stringify({
                action: 'print',
                title: title,
                contents: contents
            }), '*');
            window.addEventListener('message', function messageHandler(event) {
                if (event.origin !== window.location.origin)
                    return;
                const data = JSON.parse(event.data);
                if (data.action === 'printReady') {
                    window.frames["print_iframe"].focus();
                    window.frames["print_iframe"].print();
                }
                window.removeEventListener('message', messageHandler);
            });
        }
        generalNotify(message, type = NotifyType.Info) {
            const notification = $("#GeneralNotify").data("kendoNotification");
            notification.setOptions({
                position: {
                    top: 5,
                    left: 5
                }
            });
            notification.show(message, type);
        }
        mainWindowNotify(message, type = NotifyType.Info, clearPrevious = false) {
            appFunc.windowNotify(message, type, "#MainWindow", clearPrevious);
        }
        itemWindowNotify(message, type = NotifyType.Info, clearPrevious = false) {
            appFunc.windowNotify(message, type, "#ItemWindow", clearPrevious);
        }
        windowNotify(message, type, windowName, clearPrevious = false) {
            const notification = $("#WindowNotify").data("kendoNotification");
            if (clearPrevious)
                notification.hide();
            const winPos = $(windowName).data("kendoWindow").wrapper.offset();
            notification.setOptions({
                position: {
                    top: winPos.top + 5,
                    left: winPos.left + 5,
                    bottom: 0,
                    right: 0
                },
                show: appFunc.windowNotifyOnShow
            });
            notification.show(message.replace(/\n/g, "<br>"), type);
        }
        windowNotifyOnShow(e) {
            e.element.parent().css({
                zIndex: 22222
            });
        }
        clearWindowNotify() {
            const notification = $("#WindowNotify").data("kendoNotification");
            if (notification)
                notification.hide();
        }
    }
    SharedFunc.downloadCheck = null;
    AppFunc.SharedFunc = SharedFunc;
})(AppFunc || (AppFunc = {}));
var appFunc = new AppFunc.SharedFunc();
var AppFunc;
(function (AppFunc) {
    class AppLocalStorage {
        constructor() {
            try {
                const storage = window["localStorage"];
                const temp = "TempStorageTestValue";
                storage.setItem(temp, temp);
                storage.removeItem(temp);
                AppLocalStorage.hasLocalStorage = true;
            }
            catch (e) {
                AppLocalStorage.hasLocalStorage = false;
            }
        }
        set(key, value) {
            if (typeof value !== "undefined" && value !== null) {
                if (typeof value === "object") {
                    value = JSON.stringify(value);
                }
                if (AppLocalStorage.hasLocalStorage) {
                    localStorage.setItem(key, value);
                }
                else {
                    Cookies.set(key, value, { expires: 7777 });
                }
            }
        }
        ;
        setCookie(key, value) {
            Cookies.set(key, value, { expires: 7777 });
        }
        get(key) {
            let value;
            if (AppLocalStorage.hasLocalStorage) {
                value = localStorage.getItem(key);
            }
            else {
                value = Cookies.get(key);
            }
            try {
                value = JSON.parse(value);
            }
            catch (e) {
                value = `${value}`;
            }
            return value;
        }
        getCookie(key) {
            return Cookies.get(key);
        }
        getQuoted(key, leftIdentifier = "[", rightIdentifier = "]") {
            const value = this.get(key);
            return `${leftIdentifier}${value}${rightIdentifier}`;
        }
        remove(key) {
            if (AppLocalStorage.hasLocalStorage) {
                setTimeout(() => { localStorage.removeItem(key); }, 500);
            }
            else {
                Cookies.remove(key);
            }
        }
    }
    AppLocalStorage.hasLocalStorage = false;
    AppFunc.AppLocalStorage = AppLocalStorage;
})(AppFunc || (AppFunc = {}));
var appStore = new AppFunc.AppLocalStorage();
var AppFunc;
(function (AppFunc) {
    class AppNavigator {
        constructor() {
            this.navigateTo = (e) => {
                this.navigateToById(e.id);
            };
        }
        loginPage() {
            this.changeLocation("/account/Login");
        }
        aboutPage() {
            this.changeLocation("/home/about");
        }
        infoPage() {
            this.changeLocation("/employee/info");
        }
        logOffPage() {
            $("#logoutForm").submit();
        }
        termsInfo() {
            appFunc.showTermsInfo();
        }
        policyInfo() {
            appFunc.showPolicyInfo();
        }
        changeLocation(url) {
            $(location).attr("href", url);
        }
        navigateToById(id) {
            if (id == "teLogoff")
                this.logOffPage();
            if (id == "teHome")
                this.infoPage();
            if (id == "teAbout")
                this.aboutPage();
            if (id == "teTerms")
                this.termsInfo();
            if (id == "tePrivacy")
                this.policyInfo();
            if (id == "teLogin")
                this.loginPage();
            if (id === "teTheme")
                userSettings.toggleTheme();
        }
    }
    AppFunc.AppNavigator = AppNavigator;
})(AppFunc || (AppFunc = {}));
var navigate = new AppFunc.AppNavigator();
var AppFunc;
(function (AppFunc) {
    class AppPanel {
        panelHide(panelId) {
            $(`#${panelId}InfoBtnHide`).hide();
            $(`#${panelId}InfoDiv`).hide();
            $(`#${panelId}InfoBtnShow`).show();
            $(`#${panelId}InfoDivShivRow`).show();
            appStore.set(`${AppPanel.storagePrefix}${panelId}`, "0");
        }
        panelShow(panelId) {
            $(`#${panelId}InfoDivShivRow`).hide();
            $(`#${panelId}InfoBtnShow`).hide();
            $(`#${panelId}InfoDiv`).show("fade");
            $(`#${panelId}InfoBtnHide`).show();
            appStore.set(`${AppPanel.storagePrefix}${panelId}`, "1");
        }
        panelSetState(panelId, defaultExpandedState) {
            const panelState = `[${appStore.get(`${AppPanel.storagePrefix}${panelId}`)}]`;
            if (panelState === "[1]") {
                this.panelShow(panelId);
                return;
            }
            if (panelState === "[0]") {
                this.panelHide(panelId);
                return;
            }
            if (defaultExpandedState) {
                appStore.set(`${AppPanel.storagePrefix}${panelId}`, "1");
                this.panelShow(panelId);
            }
        }
    }
    AppPanel.storagePrefix = "aresOnlineMemberPortal_PanelState_";
    AppFunc.AppPanel = AppPanel;
})(AppFunc || (AppFunc = {}));
var appPanel = new AppFunc.AppPanel();
var AppFunc;
(function (AppFunc) {
    class ProgressManager {
        constructor() {
            this.activeRequests = 0;
            this.timeoutId = null;
            this.DEFAULT_TIMEOUT = 7000;
        }
        show() {
            if (this.activeRequests === 0) {
                appFunc.progressShow();
            }
            this.activeRequests++;
        }
        hide() {
            this.activeRequests = Math.max(0, this.activeRequests - 1);
            if (this.activeRequests === 0) {
                appFunc.progressHide();
            }
        }
        forceHide() {
            this.activeRequests = 0;
            appFunc.progressHide();
            this.clearTimeout();
        }
        resetAfterDelay(delay) {
            this.clearTimeout();
            this.timeoutId = window.setTimeout(() => {
                this.forceHide();
            }, delay || this.DEFAULT_TIMEOUT);
        }
        clearTimeout() {
            if (this.timeoutId !== null) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
        }
    }
    AppFunc.ProgressManager = ProgressManager;
})(AppFunc || (AppFunc = {}));
const progressManager = new AppFunc.ProgressManager();
var AresFunc;
(function (AresFunc) {
    class UserSettingsBase {
        getUserSettingsValue(settingsId) {
            return $(`#settings-${settingsId}`).val();
        }
        setUserSettingsValue(settingsId, value) {
            return $(`#settings-${settingsId}`).val(value);
        }
        settingIs(settingsId, value) {
            return $(`#settings-${settingsId}`).val() === value;
        }
    }
    AresFunc.UserSettingsBase = UserSettingsBase;
})(AresFunc || (AresFunc = {}));
var AresFunc;
(function (AresFunc) {
    class UserSettingsProperties extends AresFunc.UserSettingsBase {
        get colorTheme() { return super.getUserSettingsValue("L_Color_Theme_ID"); }
        ;
    }
    AresFunc.UserSettingsProperties = UserSettingsProperties;
})(AresFunc || (AresFunc = {}));
var AresFunc;
(function (AresFunc) {
    const nameUserSettings = "userSettings";
    class UserSettings {
        constructor() {
            this.areaName = nameUserSettings;
            this.userSettingsProperties = new AresFunc.UserSettingsProperties();
        }
        updateTheme() {
            var themeName = userSettings.userSettingsProperties.colorTheme;
            this.loadCssIfDifferent("mainTheme", "/lib/kendo-ui/styles/default-" + themeName + ".css");
            this.loadCssIfDifferent("swatchTheme", "/css/theme/" + themeName.toLowerCase() + "/" + themeName + ".css");
            Cookies.set("ARES_Member_Theme", themeName, { expires: 7777 });
        }
        setTheme(themeName) {
            $("#settings-L_Color_Theme_ID").val(themeName);
            this.updateTheme();
        }
        toggleTheme() {
            var themeName = userSettings.userSettingsProperties.colorTheme;
            if (themeName === "Main-Dark") {
                $("#teTheme span.k-button-icon").removeClass("fa-sun-bright").addClass("fa-moon");
                this.setTheme("Ocean-Blue");
            }
            else {
                $("#teTheme span.k-button-icon").removeClass("fa-moon").addClass("fa-sun-bright");
                this.setTheme("Main-Dark");
            }
        }
        getThemeName(themeId) {
            const themeNumber = parseInt(themeId, 10);
            switch (themeNumber) {
                case 1:
                    return "Ocean-Blue";
                case 2:
                    return "Main-Dark";
                case 3:
                    return "Nordic";
                case 4:
                    return "Orange";
                case 5:
                    return "Green";
                case 6:
                    return "Purple";
                default:
                    return "Ocean-Blue";
            }
        }
        loadCssIfDifferent(id, url) {
            const version = $("#idAresVersion").val().replace("0", "_");
            url = url + "?v=" + version;
            const link = $('#' + id);
            document.body.classList.add('loading-css');
            if (link.length) {
                const linkUrl = link.attr('href') + "?v=" + version;
                if (linkUrl !== url) {
                    link.attr('href', url);
                }
            }
            else {
                $('head').append($('<link>', {
                    id: id,
                    rel: 'stylesheet',
                    type: 'text/css',
                    href: url
                }));
            }
            setTimeout(() => {
                document.body.classList.remove('loading-css');
            }, 333);
        }
    }
    AresFunc.UserSettings = UserSettings;
})(AresFunc || (AresFunc = {}));
var userSettings = new AresFunc.UserSettings();
var AresFunc;
(function (AresFunc) {
    class AreaNameBase {
        constructor(areaName) {
            const ctor = this.constructor;
            this.areaName = areaName;
            ctor.areaName = areaName;
        }
        get area() {
            return this.areaName;
        }
        ;
    }
    AresFunc.AreaNameBase = AreaNameBase;
})(AresFunc || (AresFunc = {}));
var AresFunc;
(function (AresFunc) {
    class EditSaveCancelBase {
        constructor() {
            this.submit = () => {
                if (this.beforeSubmit()) {
                    $(`#${this.areaName}Form`).submit();
                }
            };
            this.submitBegin = () => {
                this.toolbarState(false);
            };
            this.submitEnd = () => {
                this.toolbarState(true);
            };
            this.submitSuccess = (data) => {
                if (data.success === true) {
                    this.onSubmitSuccess(data);
                }
                else {
                    this.onSubmitError(data);
                }
            };
        }
        init() {
            $(`#${this.areaName}Container :input`).on("input", kendoWin.dataChanged);
            this.onInit();
        }
        beforeSubmit() {
            return true;
        }
        ;
        submitFailure(data) {
            appFunc.logEventError(data.message);
        }
        onSubmitSuccess(data) {
        }
        ;
        onSubmitError(data) {
            if (!data.validModel) {
                kendoWin.openInfoWin("Alert", data.message, 500, 250);
            }
            else {
                appFunc.logEventError(data.message);
                kendoWin.openInfoWin("Alert", data.message, 500, 250);
            }
        }
        ;
        toolbarState(enableDisable) {
            const toolbar = $(`#${this.areaName}Toolbar`).data("kendoToolBar");
            if (toolbar) {
                const submitButton = $(`#btn${this.areaName}Submit`);
                const cancelButton = $(`#btn${this.areaName}Cancel`);
                toolbar.enable(submitButton, enableDisable);
                toolbar.enable(cancelButton, enableDisable);
            }
            kendoWin.hideItemWindowCloseBtn(enableDisable);
            const readOnly = enableDisable ? AppEnums.readOnly.No : AppEnums.readOnly.Yes;
            kendoUtil.containerSetReadOnly(`#${this.areaName}Form`, readOnly);
            this.onToolbarStateChanged(enableDisable);
        }
        onToolbarStateChanged(enableDisable) {
        }
    }
    AresFunc.EditSaveCancelBase = EditSaveCancelBase;
})(AresFunc || (AresFunc = {}));
var KendoFunc;
(function (KendoFunc) {
    class KendoGrid {
        gridDataChanged(dataSource, gridName) {
            if (gridName) {
                const toolbar = $(`#${gridName}Toolbar`).data("kendoToolBar");
                if (toolbar) {
                    const clearFilterButton = $(`#${gridName}ClearFilter`);
                    if (clearFilterButton) {
                        if (dataSource.filter() !== undefined && dataSource.filter() !== null) {
                            clearFilterButton.addClass("clearFilterButton");
                            toolbar.enable(clearFilterButton, true);
                        }
                        else {
                            clearFilterButton.removeClass("clearFilterButton");
                            toolbar.enable(clearFilterButton, false);
                        }
                    }
                }
            }
        }
        gridFilterReset(e, gridName) {
            if (gridName) {
                const grid = $(`#${gridName}`).data("kendoGrid");
                if (grid) {
                    grid.dataSource.filter({});
                    this.resetGridToolbar(gridName);
                }
            }
        }
        resetGridToolbar(gridName) {
            if (gridName) {
                const grid = $(`#${gridName}`).data("kendoGrid");
                if (grid) {
                    const toolbar = $(`#${gridName}Toolbar`).data("kendoToolBar");
                    if (toolbar) {
                        const clearFilterButton = $(`#${gridName}ClearFilter`);
                        if (clearFilterButton) {
                            if (grid.dataSource.filter() !== undefined) {
                                clearFilterButton.addClass("clearFilterButton");
                                toolbar.enable(clearFilterButton, true);
                            }
                            else {
                                clearFilterButton.removeClass("clearFilterButton");
                                toolbar.enable(clearFilterButton, false);
                            }
                        }
                    }
                }
            }
        }
        resetFilterGoTop(gridName, sortField, sortDescOrAsc = "desc") {
            const grid = $(`#${gridName}`).data("kendoGrid");
            if (grid) {
                grid.clearSelection();
                const pagesize = grid.dataSource.pageSize();
                grid.dataSource.query({
                    sort: { field: sortField, dir: sortDescOrAsc },
                    page: 1,
                    filter: {},
                    pageSize: pagesize
                });
            }
            setTimeout(() => {
                $(`#${gridName} div.k-grid-content`).scrollTop(0);
                this.selectTopRow(gridName);
            }, 250);
        }
        selectTopRow(gridId) {
            var grid = $(`#${gridId}`).data("kendoGrid");
            grid.clearSelection();
            setTimeout(() => {
                const row = grid.tbody.find("tr:first");
                grid.select(row);
                row.trigger("click");
            }, 50);
        }
        selectTopRowIfNoneSelected(grid) {
            if (!grid)
                return;
            if (!grid.select().hasClass("k-selected")) {
                const groupCount = grid.dataSource.group().length;
                grid.select(`tr:eq(${groupCount})`);
                if (!grid.select().hasClass("k-selected")) {
                    grid.select(`tr:eq(${groupCount + 1})`);
                }
                grid.trigger("change");
            }
        }
        onRowDoubleClick(gridName, onDoubleClickMethod) {
            gridName = kendoUtil.prefixHash(gridName);
            $(gridName).off("dblclick", " tbody > tr").on("dblclick", " tbody > tr", (e) => {
                e.preventDefault();
                onDoubleClickMethod($(gridName).data("kendoGrid").select());
                return false;
            });
        }
        addFilteredIndicatorToFilterNow(e) {
            setTimeout(() => {
                var filterCells = e.sender.element.find(".k-filtercell");
                filterCells.each(function () {
                    const cell = $(this);
                    const inputValue = cell.find("[data-bind]").val();
                    if (inputValue !== "") {
                        cell.find(".k-dropdown-wrap").addClass("filternow-applied");
                    }
                    else {
                        cell.find(".k-dropdown-wrap").removeClass("filternow-applied");
                    }
                });
            });
        }
        gridResize(gridName) {
            if (gridName != null && gridName.length > 0) {
                const gridRef = $(`#${gridName}`);
                if (gridRef && gridRef.length) {
                    const grid = $(`#${gridName}`).data("kendoGrid");
                    if (grid) {
                        grid.resize();
                    }
                }
            }
        }
        getGridDataItem(e) {
            const grid = $(e).closest("[data-role=grid]").data("kendoGrid");
            grid.clearSelection();
            const row = $(e).closest("tr");
            grid.select(row);
            const currentDataItem = grid.dataItem(grid.select());
            return currentDataItem;
        }
        refreshGrid(gridName) {
            if (!gridName)
                return;
            gridName = kendoUtil.prefixHash(gridName);
            if ($(gridName).length && $(gridName).is(":visible")) {
                const gridObj = $(gridName).data("kendoGrid");
                if (gridObj) {
                    gridObj.dataSource.read();
                }
            }
        }
        tagRefreshGrid(gridName) {
            if (!gridName)
                return;
            gridName = kendoUtil.prefixHash(gridName);
            if ($(gridName).length) {
                if (gridName === "#" + $("#idCurrentGrid").val() && $(gridName).is(":visible")) {
                    this.refreshGrid(gridName);
                }
                else {
                    $(gridName).attr("refreshGrid", 1);
                }
            }
        }
        checkRefreshGrid(gridName) {
            if (!gridName)
                return;
            gridName = kendoUtil.prefixHash(gridName);
            if ($(gridName).length && $(gridName).is(":visible")) {
                if ($(gridName).attr("refreshGrid") === "1") {
                    this.refreshGrid(gridName);
                    $(gridName).attr("refreshGrid", 0);
                }
            }
        }
    }
    KendoFunc.KendoGrid = KendoGrid;
})(KendoFunc || (KendoFunc = {}));
var kendoGrid = new KendoFunc.KendoGrid();
var KendoFunc;
(function (KendoFunc) {
    class KendoTab {
        getTabStripDataObj(tabStripId) {
            return $(kendoUtil.prefixHash(tabStripId)).data("kendoTabStrip");
        }
        tabReload(tabStripId) {
            const tabStrip = this.getTabStripDataObj(tabStripId);
            const tab = tabStrip.select();
            tabStrip.reload(tab);
        }
        tabStripOpenAnimationDuration(tabStrip, duration = 0, delay = 0) {
            if (delay > 0) {
                setTimeout(() => {
                    tabStrip.setOptions({
                        animation: {
                            open: {
                                duration: duration
                            }
                        }
                    });
                }, delay);
            }
            else {
                tabStrip.setOptions({
                    animation: {
                        open: {
                            duration
                        }
                    }
                });
            }
        }
        tabResize(tabStripId) {
            const tabStripObj = this.getTabStripDataObj(tabStripId);
            if (tabStripObj) {
                tabStripObj.resize();
            }
        }
        tabCount(tabStripId) {
            const tabStripObj = $(kendoUtil.prefixHash(tabStripId));
            if (!(tabStripObj && tabStripObj.length)) {
                return 0;
            }
            const tabStrip = tabStripObj.data("kendoTabStrip");
            if (!(tabStrip && tabStrip.items)) {
                return 0;
            }
            return tabStrip.items().length;
        }
        tabIndex(tabStripId) {
            tabStripId = kendoUtil.prefixHash(tabStripId);
            const tabCount = this.tabCount(tabStripId);
            if ((tabCount || 0) <= 0)
                return 0;
            const tabStrip = $(tabStripId).data("kendoTabStrip");
            return tabStrip.select().index();
        }
        tabGetNextIndex(tabStripId) {
            const tabCount = this.tabCount(tabStripId);
            if ((tabCount || 0) <= 0)
                return 0;
            return Math.min(this.tabIndex(tabStripId) + 1, tabCount);
        }
        tabGetPriorIndex(tabStripId) {
            return Math.max(this.tabIndex(tabStripId) - 1, 0);
        }
        currentPageTabId(tabStripId) {
            tabStripId = kendoUtil.prefixHash(tabStripId);
            const tabCount = this.tabCount(tabStripId);
            if ((tabCount || 0) <= 0)
                return null;
            const tabStrip = $(tabStripId).data("kendoTabStrip");
            return tabStrip.select().attr("id");
        }
        tabActivateByIndex(tabStripId, index, callEvent = null) {
            tabStripId = kendoUtil.prefixHash(tabStripId);
            const tabStrip = $(tabStripId).data("kendoTabStrip");
            tabStrip.select(index);
            if (callEvent)
                eval(callEvent)();
        }
        tabActivateByPageId(tabStripId, pageTabId) {
            tabStripId = kendoUtil.prefixHash(tabStripId);
            const tabStripObj = $(tabStripId);
            if (!(tabStripObj && tabStripObj.length)) {
                return;
            }
            const tabStrip = tabStripObj.data("kendoTabStrip");
            let tab;
            let findTabId;
            let tabIndex = -1;
            if (!tabStrip || !tabStrip.items || !tabStrip.items() || tabStrip.items().length <= 0)
                return;
            for (let i = 0; i < tabStrip.items().length; i++) {
                tab = $(tabStrip.items()[i]);
                findTabId = tab.attr("id");
                if (findTabId === pageTabId) {
                    tabIndex = i;
                    break;
                }
            }
            if (tabIndex >= 0) {
                tabStrip.select(tabIndex);
            }
        }
        tabNext(tabStripId) {
            tabStripId = kendoUtil.prefixHash(tabStripId);
            const tabCount = this.tabCount(tabStripId);
            if ((tabCount || 0) <= 0)
                return false;
            const tabStrip = $(tabStripId).data("kendoTabStrip");
            const currentTabNdx = tabStrip.select().index();
            const nextTab = currentTabNdx + 1;
            if ((nextTab + 1) <= tabCount) {
                tabStrip.select(nextTab);
                return true;
            }
            return false;
        }
        tabPrevious(tabStripId) {
            tabStripId = kendoUtil.prefixHash(tabStripId);
            const tabCount = this.tabCount(tabStripId);
            if ((tabCount || 0) <= 0)
                return false;
            const tabStrip = $(tabStripId).data("kendoTabStrip");
            const currentTabNdx = tabStrip.select().index();
            const nextTab = currentTabNdx - 1;
            if (nextTab >= 0) {
                tabStrip.select(nextTab);
                return true;
            }
            return false;
        }
        getCurrentPageTabAttribute(tabStripId, attribute) {
            tabStripId = kendoUtil.prefixHash(tabStripId);
            const tabStrip = $(tabStripId).data("kendoTabStrip");
            return tabStrip.select().attr(attribute);
        }
        setCurrentPageTabAttribute(tabStripId, attribute, value) {
            tabStripId = kendoUtil.prefixHash(tabStripId);
            const tabStrip = $(tabStripId).data("kendoTabStrip");
            tabStrip.select().attr(attribute, value);
        }
        getPageTabAttribute(pageTabId, attribute) {
            pageTabId = kendoUtil.prefixHash(pageTabId);
            return $(pageTabId).attr(attribute);
        }
        setPageTabAttribute(pageTabId, attribute, value) {
            pageTabId = kendoUtil.prefixHash(pageTabId);
            $(pageTabId).attr(attribute, value);
        }
        getPageTabIndexByPageId(tabStripId, pageTabId) {
            tabStripId = kendoUtil.prefixHash(tabStripId);
            const tabStripObj = $(tabStripId);
            if (!(tabStripObj && tabStripObj.length)) {
                return -1;
            }
            const tabStrip = tabStripObj.data("kendoTabStrip");
            let tab;
            let findTabId;
            let tabIndex = -1;
            if (!tabStrip || !tabStrip.items || !tabStrip.items() || tabStrip.items().length <= 0)
                return -1;
            for (let i = 0; i < tabStrip.items().length; i++) {
                tab = $(tabStrip.items()[i]);
                findTabId = tab.attr("id");
                if (findTabId === pageTabId) {
                    tabIndex = i;
                    break;
                }
            }
            return tabIndex;
        }
        tabAppend(tabStripId, pageTabTitle, pageTabId, tabContentParam, cssIcon = null, closable = false) {
            const tabStrip = this.getTabStripDataObj(tabStripId);
            if (this.tabExists(tabStrip, pageTabId, tabContentParam))
                return;
            const tabParam = this.getNewTabParameters(tabStripId, pageTabTitle, pageTabId, tabContentParam, cssIcon, closable);
            this.tabStripOpenAnimationDuration(tabStrip, 0);
            tabStrip.append(tabParam);
            this.tabStripOpenAnimationDuration(tabStrip, 200, 200);
            this.addIdToAddedTab(tabStripId, pageTabTitle, pageTabId);
        }
        tabInsertAfter(tabStripId, pageTabTitle, pageTabId, tabContentParam, cssIcon = null, closable = false, tabSelector = null) {
            const tabStrip = this.getTabStripDataObj(tabStripId);
            if (tabStrip.items().length === 0) {
                this.tabAppend(tabStripId, pageTabTitle, pageTabId, tabContentParam, cssIcon, closable);
                return;
            }
            if (this.tabExists(tabStrip, pageTabId, tabContentParam))
                return;
            if (tabSelector === null) {
                tabSelector = tabStrip.select();
            }
            const tabParam = this.getNewTabParameters(tabStripId, pageTabTitle, pageTabId, tabContentParam, cssIcon, closable);
            this.tabStripOpenAnimationDuration(tabStrip, 0);
            tabStrip.insertAfter(tabParam, tabSelector);
            this.tabStripOpenAnimationDuration(tabStrip, 200, 200);
            this.addIdToAddedTab(tabStripId, pageTabTitle, pageTabId);
        }
        tabInsertBefore(tabStripId, pageTabTitle, pageTabId, tabContentParam, cssIcon = null, closable = false, tabSelector = null) {
            const tabStrip = this.getTabStripDataObj(tabStripId);
            if (tabStrip.items().length === 0) {
                this.tabAppend(tabStripId, pageTabTitle, pageTabId, tabContentParam, cssIcon, closable);
                return;
            }
            if (this.tabExists(tabStrip, pageTabId, tabContentParam))
                return;
            if (tabSelector === null) {
                tabSelector = tabStrip.select();
            }
            const tabParam = this.getNewTabParameters(tabStripId, pageTabTitle, pageTabId, tabContentParam, cssIcon, closable);
            this.tabStripOpenAnimationDuration(tabStrip, 0);
            tabStrip.insertBefore(tabParam, tabSelector);
            this.tabStripOpenAnimationDuration(tabStrip, 200, 200);
            this.addIdToAddedTab(tabStripId, pageTabTitle, pageTabId);
        }
        tabExists(tabStrip, pageTabId, tabContentParam) {
            const tabIndex = this.getExistingPageTabIndex(tabStrip, pageTabId);
            if (tabIndex >= 0) {
                tabStrip.select(tabIndex);
                if (tabContentParam.existsCallback) {
                    tabContentParam.existsCallback();
                }
                return true;
            }
            return false;
        }
        getNewTabParameters(tabStripId, pageTabTitle, pageTabId, tabContentParam, cssIcon = null, closable = false) {
            if (tabContentParam.content) {
                return {
                    text: this.getAddNewPageTabCaption(pageTabTitle, cssIcon, closable),
                    encoded: false,
                    content: tabContentParam.content
                };
            }
            return {
                text: this.getAddNewPageTabCaption(pageTabTitle, cssIcon, closable),
                encoded: false,
                contentUrl: (tabContentParam).url
            };
        }
        addIdToAddedTab(tabStripId, pageTabTitle, pageTabId) {
            const tabStrip = this.getTabStripDataObj(tabStripId);
            const insertedTab = tabStrip.tabGroup.children("li").find(`.k-link:contains('${pageTabTitle}')`);
            const parent = insertedTab.parent();
            $.when(parent.attr("id", pageTabId)).done(() => {
                $(`${tabStripId}`).trigger("added", pageTabId);
            });
        }
        getAddNewPageTabCaption(pageTabTitle, cssIcon = null, closable = false) {
            if (closable) {
                pageTabTitle += `<span data-type='removeTab' class='closableTabContainer'><a title='Close Tab' class='closableTabButton'><span class='fal fa-times-square k-sprite'></span></a></span>`;
            }
            if (cssIcon !== null && cssIcon.length > 0) {
                pageTabTitle = `<span class='${cssIcon} k-sprite'></span>&nbsp${pageTabTitle}`;
            }
            return pageTabTitle;
        }
        getExistingPageTabIndex(tabStripId, pageTabId) {
            const tabStrip = typeof tabStripId === "string" ? this.getTabStripDataObj(tabStripId) : tabStripId;
            let tab;
            let findPageTabId;
            let tabIndex = -1;
            if (!tabStrip || !tabStrip.items)
                return -1;
            pageTabId = kendoUtil.prefixHash(pageTabId);
            for (let i = 0; i < tabStrip.items().length; i++) {
                tab = $(tabStrip.items()[i]);
                findPageTabId = `#${tab.attr("id")}`;
                if (findPageTabId === pageTabId) {
                    tabIndex = i;
                    break;
                }
            }
            return tabIndex;
        }
        configureCloseTab(tabStripId) {
            const tabStrip = this.getTabStripDataObj(tabStripId);
            tabStrip.tabGroup.on("click", "[data-type='removeTab']", e => {
                e.preventDefault();
                e.stopPropagation();
                const item = $(e.target).closest(".k-item");
                tabStrip.remove(item.index());
                $(`#${tabStripId}`).trigger("removed");
                const tabsCount = tabStrip.items().length;
                if (item.hasClass("k-active")) {
                    const lestTabId = $(`#${tabStripId}`).attr("data-last-tab-id");
                    const tabIndex = this.getExistingPageTabIndex(tabStripId, lestTabId);
                    if (tabsCount > 0 && tabIndex >= 0) {
                        tabStrip.select(tabIndex);
                    }
                    else {
                        if (tabsCount === 0)
                            tabStrip.select(0);
                    }
                }
            });
            tabStrip.setOptions({
                activate() { kendoTab.onClosableTabeTabActivate(tabStripId); },
            });
            $(`#${tabStripId}`).attr("data-last-tab-id", "").attr("data-current-tab-id", "")
                .on("removed", event => {
                this.onTabRemoved(tabStripId);
            }).on("added", (event, obj) => {
                this.onTabAdded(tabStripId, obj);
            });
        }
        closeAllTabs(tabStripId, keepActiveTabOpen = false) {
            const tabStrip = this.getTabStripDataObj(tabStripId);
            if (!tabStrip || !tabStrip.items || !tabStrip.items() || tabStrip.items().length <= 0)
                return;
            if (keepActiveTabOpen) {
                if (tabStrip.items().length <= 1)
                    return;
                const activeTabId = this.getCurrentPageTabAttribute(tabStripId, "id");
                let tab;
                let findPageTabId;
                for (let i = tabStrip.items().length; i > 0; i--) {
                    tab = $(tabStrip.items()[i - 1]);
                    findPageTabId = tab.attr("id");
                    if (findPageTabId !== activeTabId) {
                        tabStrip.remove(i - 1);
                    }
                }
            }
            else {
                tabStrip.remove(tabStrip.tabGroup.children());
            }
            $(`#${tabStripId}`).trigger("removed");
        }
        onClosableTabeTabActivate(tabStripId) {
            const tabPageId = kendoTab.currentPageTabId(tabStripId);
            $(`#${tabStripId}`)
                .attr("data-last-tab-id", $(`#${tabStripId}`).attr("data-current-tab-id"))
                .attr("data-current-tab-id", tabPageId);
        }
        onTabRemoved(tabStripId) {
        }
        onTabAdded(tabStripId, pageTabId = "") {
            this.tabActivateByPageId(tabStripId, pageTabId);
        }
        configureSortableTab(tabStripId) {
            $(`#${tabStripId} ul.k-tabstrip-items`).kendoSortable({
                filter: "li.k-item",
                axis: "x",
                container: `#${tabStripId} ul.k-tabstrip-items`,
                hint(element) {
                    return $(`<div id='hint' class='k-widget k-header k-tabstrip'><ul class='k-tabstrip-items k-reset'><li class='k-item k-active k-tab-on-top'>${element.html()}</li></ul></div>`);
                },
                start(e) {
                    const tabStrip = $(kendoUtil.prefixHash(tabStripId)).data("kendoTabStrip");
                    tabStrip.activateTab(e.item);
                },
                change(e) {
                    const tabStrip = $(kendoUtil.prefixHash(tabStripId)).data("kendoTabStrip");
                    const reference = tabStrip.tabGroup.children().eq(e.newIndex);
                    if (e.oldIndex < e.newIndex) {
                        tabStrip.insertAfter(e.item, reference);
                    }
                    else {
                        tabStrip.insertBefore(e.item, reference);
                    }
                }
            });
        }
    }
    KendoFunc.KendoTab = KendoTab;
})(KendoFunc || (KendoFunc = {}));
var kendoTab = new KendoFunc.KendoTab();
var KendoFunc;
(function (KendoFunc) {
    class KendoUtil {
        containerSetReadOnly(container, readOnlyState) {
            var inputId = "";
            var dataRole = "";
            var dataRoleName = "";
            var input = null;
            const dateRoles = {
                "datepicker": "kendoDatePicker",
                "dropdownlist": "kendoDropDownList",
                "multiselect": "kendoMultiSelect",
                "numerictextbox": "kendoNumericTextBox",
                "timepicker": "kendoTimePicker",
                "datetimepicker": "kendoDateTimePicker",
                "maskedtextbox": "kendoMaskedTextBox",
                "combobox": "kendoComboBox"
            };
            $(`${container} *`).filter(":input:enabled").each(function () {
                input = $(this);
                inputId = input.attr("id");
                dataRole = input.attr("data-role");
                dataRoleName = "";
                if (inputId != undefined) {
                    if (dataRole != undefined) {
                        dataRoleName = dateRoles[dataRole];
                        if (dataRoleName != undefined) {
                            kendoUtil.setReadOnly(`#${inputId}`, readOnlyState, dateRoles[dataRole]);
                        }
                    }
                    else {
                        kendoUtil.setReadOnly(`#${inputId}`, readOnlyState);
                    }
                }
            });
        }
        setReadOnly(idRef, readOnly = false, kendoDataObjName) {
            if ($(idRef).length) {
                if (kendoDataObjName != null) {
                    $(idRef).data(kendoDataObjName).readonly(readOnly);
                }
                else {
                    $(idRef).prop("readonly", readOnly);
                }
            }
        }
        prefixHash(idName) {
            return idName.charAt(0) !== "#" ? `#${idName}` : idName;
        }
    }
    KendoFunc.KendoUtil = KendoUtil;
})(KendoFunc || (KendoFunc = {}));
var kendoUtil = new KendoFunc.KendoUtil();
var KendoFunc;
(function (KendoFunc) {
    class WindowProp {
        constructor() {
            this.afterOnResizeMethod = null;
            this.overrideCloseMethod = null;
        }
    }
    ;
    class KendoWin {
        constructor() {
            this.exitMainWindow = () => {
                $("#DataChangedInd").val(0);
                this.closeMainWindow();
            };
            this.exitItemWindow = () => {
                $("#DataChangedInd").val(0);
                this.closeItemWindow();
            };
            this.deviceResized = () => {
                this.triggerWindowResize();
            };
        }
        windowTitlePrefix() {
            const windowTitle = window.windowTitlePrefix;
            if (windowTitle && windowTitle.length > 1) {
                return windowTitle;
            }
            return "<span id='image_loading_win1' class='progressIndWin'><\/span><span class='site-brand-win'></span><span class='site-win-title'></span> - ";
        }
        setMainWindowProp(scrollContainerId, toolbarId, offset, afterOnResizeMethod = null, overrideCloseMethod = null) {
            KendoWin.mainWindowProp = { scrollContainerId, toolbarId, offset, afterOnResizeMethod, overrideCloseMethod };
            this.onMainWindowResize();
        }
        setItemWindowProp(scrollContainerId, toolbarId, offset, afterOnResizeMethod = null, overrideCloseMethod = null) {
            KendoWin.itemWindowProp = { scrollContainerId, toolbarId, offset, afterOnResizeMethod, overrideCloseMethod };
            this.onItemWindowResize();
        }
        openMainWin(winTitle, winUrl, itemData, winWidth = 500, winHeight = 0, trackChanges) {
            $("#MainWindowInitWidth").val(winWidth);
            $("#MainWindowInitHeight").val(winHeight);
            this.openWin("MainWindow", winTitle, winWidth, winHeight, winUrl, trackChanges, false, true, itemData, 50);
        }
        openItemWin(winTitle, winUrl, itemData, winWidth = 500, winHeight = 0, trackChanges = true) {
            $("#ItemWindowInitWidth").val(winWidth);
            $("#ItemWindowInitHeight").val(winHeight);
            this.openWin("ItemWindow", winTitle, winWidth, winHeight, winUrl, trackChanges, false, true, itemData, 50);
        }
        openPleaseWaitWindow(winHeight = 150) {
            const pleaseWaitWin = $("#PleaseWaitWindow").data("kendoWindow");
            const $titleSpan = pleaseWaitWin.wrapper.find(".k-window-title");
            const winName = "PleaseWaitWindow";
            $titleSpan.html(this.windowTitlePrefix() + "<span id=\"" + winName + "Title\">Please Wait</span>");
            winHeight = winHeight || 150;
            pleaseWaitWin.center();
            if (winHeight / 80 > 1) {
                pleaseWaitWin.wrapper.css({
                    top: 80
                });
            }
            pleaseWaitWin.open();
        }
        setPleaseWaitMessage(message) {
            $("#idPleaseWaitWindowMsg").html(message);
        }
        closePleaseWaitWindow() {
            $("#PleaseWaitWindow").data("kendoWindow").close();
        }
        closeMainWindow() {
            $("#MainWindow").data("kendoWindow").close();
        }
        closeItemWindow() {
            $("#ItemWindow").data("kendoWindow").close();
        }
        mainWindowTitle(t) {
            $("#MainWindowTitle").html(t);
        }
        itemWindowTitle(t) {
            $("#ItemWindowTitle").html(t);
        }
        confirmCloseMainWindow(yesNoVal) {
            if (yesNoVal == 1) {
                kendoWin.exitMainWindow();
            }
        }
        confirmCloseItemWindow(yesNoVal) {
            if (yesNoVal == 1) {
                kendoWin.exitItemWindow();
            }
        }
        hideMainWindowCloseBtn(showHide) {
            this.hideWindowCloseBtn(showHide, "#MainWindow");
        }
        hideItemWindowCloseBtn(showHide) {
            this.hideWindowCloseBtn(showHide, "#ItemWindow");
        }
        hideWindowCloseBtn(showHide, winName) {
            const mainWin = $(winName);
            mainWin.parent().find(KendoWin.titleBarAction).css("visibility", showHide ? "visible" : "hidden");
        }
        onMainWindowActivate() {
            KendoWin.mainWindowIsActive = true;
        }
        onItemWindowActivate() {
            KendoWin.itemWindowIsActive = true;
        }
        onMainWindowResize() {
            if (KendoWin.mainWindowIsActive && KendoWin.mainWindowProp) {
                const toolbarHeight = 47;
                const offset = 50;
                const contentSize = Math.floor($("#MainWindow").height()) - toolbarHeight - offset;
                $(KendoWin.mainWindowProp.scrollContainerId).height(contentSize);
                if (KendoWin.mainWindowProp.afterOnResizeMethod !== null) {
                    KendoWin.mainWindowProp.afterOnResizeMethod();
                }
            }
        }
        onItemWindowResize() {
            if (KendoWin.itemWindowIsActive && KendoWin.itemWindowProp) {
                const toolbarHeight = 47;
                const offset = 50;
                const contentSize = Math.floor($("#ItemWindow").height()) - toolbarHeight - offset;
                $(KendoWin.itemWindowProp.scrollContainerId).height(contentSize);
                if (KendoWin.itemWindowProp.afterOnResizeMethod !== null) {
                    KendoWin.itemWindowProp.afterOnResizeMethod();
                }
            }
            ;
        }
        onMainWindowDeactivate() {
            if (KendoWin.mainWindowProp && KendoWin.mainWindowProp.overrideCloseMethod && KendoWin.mainWindowProp.overrideCloseMethod !== null && KendoWin.mainWindowProp.overrideCloseMethod.length > 1) {
                KendoWin.mainWindowProp.overrideCloseMethod();
            }
            else {
                KendoWin.mainWindowIsActive = false;
                $("#MainWindow").data("kendoWindow").content("Please wait...");
            }
        }
        onItemWindowDeactivate() {
            if (KendoWin.itemWindowProp && KendoWin.itemWindowProp.overrideCloseMethod && KendoWin.itemWindowProp.overrideCloseMethod !== null && KendoWin.itemWindowProp.overrideCloseMethod.length > 1) {
                KendoWin.itemWindowProp.overrideCloseMethod();
            }
            else {
                KendoWin.itemWindowIsActive = false;
                $("#ItemWindow").data("kendoWindow").content("Please wait...");
            }
        }
        onMainWindowClose(e) {
            if ($("#DataChangedInd").val() == 1) {
                e.preventDefault();
                kendoWin.openYesNoWin("Confirm", "Cancel modifications and exit?", "kendoWin.confirmCloseMainWindow");
            }
        }
        onItemWindowClose(e) {
            if ($("#DataChangedInd").val() == 1) {
                e.preventDefault();
                kendoWin.openYesNoWin("Confirm", "Cancel modifications and exit?", "kendoWin.confirmCloseItemWindow");
            }
        }
        dataChanged() {
            $("#DataChangedInd").val(1);
        }
        openWin(winName, winTitle, winWidth, winHeight, winUrl, trackChanges, winMaximize, autoMaximize, objectParam, topOffset, postCloseMethod) {
            const win = $(`#${winName}`);
            win.parent().find(KendoWin.titleBarAction).css("visibility", "visible");
            const mainWin = win.data("kendoWindow");
            const isMobile = ($("#idIsMobile").val() == "1");
            mainWin.restore();
            trackChanges = trackChanges || false;
            if (!winMaximize)
                winMaximize = false;
            autoMaximize = autoMaximize || false;
            if (winHeight == 0 && winWidth == 0)
                winMaximize = true;
            topOffset = topOffset || 40;
            $("#DataChangedInd").val(0);
            mainWin.content("Please wait...");
            const docWidth = $(window).width();
            const docHeight = $(window).height();
            if (autoMaximize) {
                if (docWidth < winWidth || docHeight < winHeight || isMobile) {
                    winMaximize = true;
                }
            }
            if (winMaximize) {
                mainWin.maximize();
            }
            else {
                winWidth = Math.min(winWidth, docWidth - 20);
                if (winHeight == 0) {
                    winHeight = docHeight - topOffset - 20;
                }
                else {
                    winHeight = Math.min(winHeight, docHeight - topOffset);
                }
                mainWin.wrapper.css({
                    width: winWidth,
                    height: winHeight
                });
            }
            const $titleSpan = mainWin.wrapper.find(".k-window-title");
            $titleSpan.html(this.windowTitlePrefix() + "<span id=\"" + winName + "Title\">" + winTitle + "</span>");
            mainWin.refresh({
                url: winUrl,
                data: objectParam
            });
            mainWin.center();
            if (!winMaximize && (winHeight + (topOffset * 2) < docHeight)) {
                mainWin.wrapper.css({
                    top: topOffset
                });
            }
            mainWin.open();
        }
        openYesNoWin(winTitle, tcMsg, methodFunc, jsonCargo = null, winWidth, winHeight, yesNoWindowExplicitYesNo = false) {
            const yesNoWin = $("#YesNoWindow").data("kendoWindow");
            tcMsg = tcMsg || "Cancel?";
            $("#idYesNoFunc").val(methodFunc);
            $("#idYesNoMsg").html(tcMsg);
            if (jsonCargo != null) {
                KendoWin.yesNoWindowCargo = encodeURIComponent(JSON.stringify(jsonCargo));
            }
            this.setYesNoWin(0);
            winWidth = winWidth || 500;
            winHeight = winHeight || 250;
            let winMaximize = false;
            const docWidth = $(window).width();
            const docHeight = $(window).height();
            if (docWidth < winWidth || docHeight < winHeight) {
                winMaximize = true;
            }
            if (winMaximize) {
                yesNoWin.maximize();
            }
            else {
                winWidth = Math.min(winWidth, docWidth - 20);
                if (winHeight == 0) {
                    winHeight = docHeight - 50;
                }
                else {
                    winHeight = Math.min(winHeight, docHeight - 50);
                }
                yesNoWin.wrapper.css({
                    width: winWidth,
                    height: winHeight,
                    top: 20
                });
            }
            const $titleSpan = yesNoWin.wrapper.find(".k-window-title");
            $titleSpan.html(this.windowTitlePrefix() + winTitle);
            yesNoWin.center();
            if (!winMaximize && (winHeight / 80) > 1) {
                yesNoWin.wrapper.css({
                    top: 80
                });
            }
            yesNoWin.open();
            $("#idYesNoBtnNo").focus();
        }
        closeYesNoWindow() {
            $("#idYesNoBtnNo").data("kendoWindow").close();
        }
        setYesNoWin(yesNoValue) {
            $("#idYesNo").val(yesNoValue);
            const yesNoWin = $("#YesNoWindow").data("kendoWindow");
            yesNoWin.close();
            this.yesNoCallEvent($("#idYesNoFunc").val(), yesNoValue);
        }
        yesNoCallEvent(methodName, yesNoValue) {
            const method = eval(`(${methodName})`);
            let param = null;
            if (yesNoValue === 1) {
                if (KendoWin.yesNoWindowCargo != null) {
                    param = JSON.parse(decodeURIComponent(KendoWin.yesNoWindowCargo));
                }
            }
            method(yesNoValue, param);
        }
        openInfoWin(winTitle, message, winWidth, winHeight, func) {
            const infoWin = $("#InfoWindow").data("kendoWindow");
            $("#idInfoMsg").html(message);
            winWidth = winWidth || 500;
            winHeight = winHeight || 250;
            let winMaximize = false;
            const docWidth = $(window).width();
            const docHeight = $(window).height();
            if (docWidth < winWidth || docHeight < winHeight) {
                winMaximize = true;
            }
            if (winMaximize) {
                infoWin.maximize();
            }
            else {
                if (winHeight == 0) {
                    winHeight = docHeight - 50;
                }
                else {
                    winHeight = Math.min(winHeight, docHeight - 100);
                }
                infoWin.wrapper.css({
                    width: winWidth,
                    height: winHeight,
                    top: 20
                });
            }
            const $titleSpan = infoWin.wrapper.find(".k-window-title");
            $titleSpan.html(this.windowTitlePrefix() + winTitle);
            infoWin.center();
            if (!winMaximize && (winHeight / 80) > 1) {
                infoWin.wrapper.css({
                    top: 80
                });
            }
            if (func) {
                infoWin.bind("deactivate", func);
            }
            infoWin.open();
            $("#idInfoBtnOk").focus();
        }
        closeInfoWindow() {
            $("#InfoWindow").data("kendoWindow").close();
        }
        triggerWindowResize() {
            this.centerWinAfterResize("#MainWindow", $("#MainWindowInitHeight").val() == 0, false, 50);
            this.centerWinAfterResize("#ItemWindow", $("#ItemWindowInitHeight").val() == 0, false, 50);
            this.centerWinAfterResize("#YesNoWindow", false, true);
            this.centerWinAfterResize("#InfoWindow", false, true);
            this.centerWinAfterResize("#SessionTimeoutWindow", false, true);
        }
        xcenterWinAfterResize(winRef, expandHeight, vCenter, topOffset) {
            const docWidth = $(window).width();
            const docHeight = $(window).height();
            topOffset = topOffset || 40;
            const winObj = $(winRef).data("kendoWindow");
            const winHeight = docHeight - 50;
            if ($(winRef).is(":visible")) {
                if (!$(winRef).parent().hasClass("k-window-maximized")) {
                    if (expandHeight) {
                        winObj.wrapper.css({
                            height: winHeight - topOffset
                        });
                    }
                    let newLeftPos = 0;
                    if (!vCenter) {
                        if (expandHeight) {
                            newLeftPos = docWidth / 2 - winObj.wrapper.width() / 2;
                            newLeftPos = Math.max(newLeftPos, 0);
                            winObj.wrapper.css({
                                left: newLeftPos,
                                top: (topOffset / 2)
                            });
                        }
                        else {
                            winObj.center();
                            if (winHeight + (topOffset * 2) < docHeight) {
                                winObj.wrapper.css({
                                    top: topOffset
                                });
                            }
                        }
                    }
                    else {
                        newLeftPos = docWidth / 2 - winObj.wrapper.width() / 2;
                        newLeftPos = Math.max(newLeftPos, 0);
                        winObj.wrapper.css({
                            left: newLeftPos
                        });
                    }
                }
                winObj.trigger("resize");
            }
        }
        centerWinAfterResize(winRef, expandHeight, vCenter, topOffset) {
            const winData = $(winRef).data("kendoWindow");
            if ($(winRef).is(":visible")) {
                if (!$(winRef).parent().hasClass("k-window-maximized")) {
                    if (expandHeight) {
                        topOffset = topOffset || 40;
                        const docHeight = $(window).height();
                        const winHeight = Math.max(50, docHeight - topOffset - 20);
                        ;
                        winData.wrapper.css({
                            height: winHeight,
                            top: topOffset
                        });
                        winData.center();
                    }
                    else {
                        let newLeftPos = 0;
                        const docWidth = $(window).width();
                        newLeftPos = docWidth / 2 - winData.wrapper.width() / 2;
                        newLeftPos = Math.max(newLeftPos, 0);
                        winData.wrapper.css({
                            top: topOffset,
                            left: newLeftPos
                        });
                    }
                }
            }
            winData.trigger("resize");
            winData.resize();
        }
    }
    KendoWin.titleBarAction = ".k-window-titlebar-action";
    KendoWin.mainWindowIsActive = false;
    KendoWin.itemWindowIsActive = false;
    KendoWin.yesNoWindowCargo = null;
    KendoFunc.KendoWin = KendoWin;
})(KendoFunc || (KendoFunc = {}));
var kendoWin = new KendoFunc.KendoWin();
var AresFunc;
(function (AresFunc) {
    const nameEmpInfo = "empInfo";
    class EmpInfo {
        constructor() {
            this.areaName = nameEmpInfo;
        }
        changeDepPassword(depId) {
            const depName = $(`#depFullName${depId}`).html();
            const objectParam = { depId, depName };
            kendoWin.openItemWin("Change Dependent Password", "/Employee/ChangeDependentPassword", objectParam, 700, 560);
        }
    }
    AresFunc.EmpInfo = EmpInfo;
})(AresFunc || (AresFunc = {}));
var empInfo = new AresFunc.EmpInfo();
var AresFunc;
(function (AresFunc) {
    const nameEmpPersonalContactArea = "empPersonalContact";
    class EmpPersonalContact {
        constructor() {
            this.areaName = nameEmpPersonalContactArea;
        }
        openManagePersonalContact() {
            const objectParam = null;
            kendoWin.openMainWin("Manage Personal Contact", "/PersonalContact/ManagePersonalContact", objectParam, 700, 0);
        }
        openEditEmail() {
            empPersonalContact.openEdit(1000);
        }
        cancelEmailRequest() {
            empPersonalContact.askCancel("email");
        }
        cancelEmailRequestConfirmed(yesNoVal, _objectParam) {
            empPersonalContact.submitCancel(yesNoVal, "/PersonalContact/CancelPersonalEmailRequest", "email");
        }
        verifyEmailCode() {
            empPersonalContact.askVerify("#otp", "email");
        }
        openEditPhone() {
            empPersonalContact.openEdit(1001);
        }
        cancelPhoneRequest() {
            empPersonalContact.askCancel("phone");
        }
        cancelPhoneRequestConfirmed(yesNoVal, _objectParam) {
            empPersonalContact.submitCancel(yesNoVal, "/PersonalContact/CancelPersonalPhoneRequest", "phone");
        }
        verifyPhoneCode() {
            empPersonalContact.askVerify("#otpPhone", "phone");
        }
        askCancel(channel) {
            const channelLabel = channel === "email" ? "Email" : "Phone";
            const callback = channel === "email"
                ? "empPersonalContact.cancelEmailRequestConfirmed"
                : "empPersonalContact.cancelPhoneRequestConfirmed";
            kendoWin.openYesNoWin(`Cancel ${channelLabel} Request`, `Are you sure you want to cancel the pending personal ${channel} change request?`, callback, null, 500, 300);
        }
        submitCancel(yesNoVal, url, channel) {
            if (yesNoVal !== 1) {
                return;
            }
            const channelLabel = channel === "email" ? "Email" : "Phone";
            $.ajax({
                url: url,
                type: "POST",
                cache: false,
                data: {
                    __RequestVerificationToken: appFunc.getVerificationToken()
                },
                success(result) {
                    if (result && result.Success) {
                        kendoWin.openInfoWin(`${channelLabel} Request Cancelled`, result.Message || `Your pending personal ${channel} change request has been cancelled.`);
                        empPersonalContact.openManagePersonalContact();
                    }
                    else {
                        kendoWin.openInfoWin("Cancel Failed", (result && result.Message) || "Unable to cancel the request.");
                    }
                },
                error() {
                    kendoWin.openInfoWin("Error", "An error occurred while cancelling the request. Please try again.");
                }
            });
        }
        askVerify(otpSelector, channel) {
            const widget = $(otpSelector).data("kendoOTPInput");
            const code = widget ? (widget.value() || "") : "";
            if (!/^\d{6}$/.test(code)) {
                kendoWin.openInfoWin("Invalid Code", "Please enter the 6-digit verification code.");
                return;
            }
            const url = channel === "email"
                ? "/PersonalContact/VerifyPersonalEmailCode"
                : "/PersonalContact/VerifyPersonalPhoneCode";
            empPersonalContact.submitVerify(code, url, channel);
        }
        submitVerify(code, url, channel) {
            const channelLabel = channel === "email" ? "Email" : "Phone";
            $.ajax({
                url: url,
                type: "POST",
                cache: false,
                data: {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    code: code
                },
                success(result) {
                    if (result && result.Success) {
                        kendoWin.openInfoWin(`${channelLabel} Verified`, result.Message || `Your personal ${channel} has been updated.`);
                        kendoWin.exitMainWindow();
                    }
                    else {
                        empPersonalContact.openManagePersonalContact();
                        kendoWin.openInfoWin("Verification Failed", (result && result.Message) || "Unable to verify the code.");
                    }
                },
                error() {
                    kendoWin.openInfoWin("Error", "An error occurred while verifying the code. Please try again.");
                }
            });
        }
        openEdit(methodId) {
            const objectParam = null;
            const url = `/PersonalContact/EditPersonalContact?methodId=${methodId}`;
            kendoWin.openItemWin("Update Personal Contact", url, objectParam, 700, 0);
        }
    }
    AresFunc.EmpPersonalContact = EmpPersonalContact;
})(AresFunc || (AresFunc = {}));
var empPersonalContact = new AresFunc.EmpPersonalContact();
var AresFunc;
(function (AresFunc) {
    const nameOeEmp = "oeEmp";
    class OeEmp {
        constructor() {
            this.areaName = nameOeEmp;
        }
        oeEmpInit() {
            const payload = this.payload();
            const urlParam = `?payload=${payload}`;
            var pageTabs;
            if ($("#hidSubmittedDate").val() != "") {
                pageTabs = [`/Employee/OeEmpSummary${urlParam}`];
            }
            else {
                pageTabs = [
                    `/Employee/OeEmpDemogr${urlParam}`,
                    `/Employee/OeEmpDepList${urlParam}`,
                    `/Employee/OeEmpDocList${urlParam}`,
                    `/Employee/OeEmpPlans${urlParam}`,
                    `/MedicalPcp/OeEmpMedPcp${urlParam}`,
                    `/DentalPcp/OeEmpDenPcp${urlParam}`,
                    `/Employee/OeEmpSummary${urlParam}`
                ];
            }
            var ts = $(OeEmp.oeEmpTabId).kendoTabStrip({
                animation: false,
                contentUrls: pageTabs,
                activate: this.oeEmpTabActivate,
                select: this.oeEmpTabSelect,
                navigatable: false,
                error: appFunc.logEventError,
                scrollable: false
            }).data('kendoTabStrip');
            ts.select(0);
        }
        oeEmpTabGetPageIdByIndex(index) {
            return OeEmp.empPageTabIds[index];
        }
        oeEmpTabSelect(e) {
            const toolbar = $(OeEmp.oeEmpToolbarId).data("kendoToolBar"), btnNext = $(`#btn${nameOeEmp}Next`), btnSubmit = $(`#btn${nameOeEmp}Submit`), btnEmpEdit = $(`#btn${nameOeEmp}EmpEdit`), btnDepAdd = $(`#btn${nameOeEmp}DepAdd`), btnDocAdd = $(`#btn${nameOeEmp}DocAdd`), btnPlanEdit = $(`#btn${nameOeEmp}PlanEdit`), btnBack = $(`#btn${nameOeEmp}Back`), btnClose = $(`#btn${nameOeEmp}Close`);
            toolbar.enable(btnNext, false);
            toolbar.enable(btnBack, false);
            toolbar.show(btnNext);
            toolbar.hide(btnEmpEdit);
            toolbar.hide(btnDepAdd);
            toolbar.hide(btnDocAdd);
            toolbar.hide(btnPlanEdit);
            toolbar.hide(btnSubmit);
        }
        oeEmpTabActivate(e) {
            const toolbar = $(OeEmp.oeEmpToolbarId).data("kendoToolBar"), btnNext = $(`#btn${nameOeEmp}Next`), btnSubmit = $(`#btn${nameOeEmp}Submit`), btnEmpEdit = $(`#btn${nameOeEmp}EmpEdit`), btnDepAdd = $(`#btn${nameOeEmp}DepAdd`), btnDocAdd = $(`#btn${nameOeEmp}DocAdd`), btnPlanEdit = $(`#btn${nameOeEmp}PlanEdit`), btnBack = $(`#btn${nameOeEmp}Back`), btnClose = $(`#btn${nameOeEmp}Close`);
            toolbar.enable(btnNext, false);
            toolbar.enable(btnBack, false);
            toolbar.show(btnNext);
            toolbar.hide(btnEmpEdit);
            toolbar.hide(btnDepAdd);
            toolbar.hide(btnDocAdd);
            toolbar.hide(btnPlanEdit);
            toolbar.hide(btnSubmit);
            const currentTabId = kendoTab.currentPageTabId(OeEmp.oeEmpTabId);
            $("#hidTabSectionId").val(currentTabId);
            const tabIndex = kendoTab.tabIndex(OeEmp.oeEmpTabId);
            const tabCount = kendoTab.tabCount(OeEmp.oeEmpTabId);
            if (tabIndex >= 0 && (tabIndex + 1) < tabCount) {
                toolbar.enable(btnNext, true);
            }
            if (tabIndex > 0) {
                toolbar.enable(btnBack, true);
            }
            switch (currentTabId) {
                case "tabEmp":
                    toolbar.show(btnEmpEdit);
                    break;
                case "tabDep":
                    toolbar.show(btnDepAdd);
                    break;
                case "tabDocs":
                    toolbar.show(btnDocAdd);
                    break;
                case "tabPlans":
                    toolbar.show(btnPlanEdit);
                    break;
                case "tabMedPcp":
                    break;
                case "tabDenPcp":
                    break;
                case "tabReview":
                    toolbar.show(btnSubmit);
                    break;
                default:
                    break;
            }
            const reloadTab = kendoTab.getCurrentPageTabAttribute(OeEmp.oeEmpTabId, "data-refresh-tab");
            if (reloadTab === "1") {
                kendoTab.setPageTabAttribute(currentTabId, "data-refresh-tab", "0");
                kendoTab.tabReload(OeEmp.oeEmpTabId);
            }
        }
        setReloadTabs() {
            kendoTab.setPageTabAttribute("tabPlans", "data-refresh-tab", "1");
            kendoTab.setPageTabAttribute("tabMedPcp", "data-refresh-tab", "1");
            kendoTab.setPageTabAttribute("tabDenPcp", "data-refresh-tab", "1");
            kendoTab.setPageTabAttribute("tabReview", "data-refresh-tab", "1");
        }
        validate_tabEmp() {
            if ($("#EmpEr_OE_Email_Required_Ind").val().toLowerCase() === "true" && $("#OeEmpDemographics_Pri_Email").val() === "") {
                kendoWin.openYesNoWin("Email is required", "Your employer is requesting your email address, would you like to input your email address now?", "oeEmp.oeEmpAddEmailNow");
                return false;
            }
            return true;
        }
        validate_tabDep() {
            if ($("#hidAskDepAdded").val() == "1") {
                kendoWin.openYesNoWin("Please confirm", "Have you added all of your dependents (i.e. spouse and children)?", "oeEmp.oeEmpAddedAllDependents");
                return false;
            }
            else {
                return true;
            }
        }
        validate_tabDocs() {
            return true;
        }
        validate_tabPlans() {
            if ($("#PlanSelectionValid").val() != "True") {
                kendoWin.openYesNoWin("Plans are invalid", "You must select new plan(s) because the family makeup changed (i.e. added/changed/removed dependents); would you like to select new plans now?", "oeEmp.oeEmpPlanEditNow");
            }
            else {
                if ($("#NewPlansElected").val() != "True") {
                    const selectPlanMsg = $("#SelectPlanMessage").val();
                    kendoWin.openYesNoWin("Select plans to enroll in", selectPlanMsg + "<br/><br />Would you like to select new plans now?", "oeEmp.oeEmpPlanEditNow", null, 500, 250);
                }
                else {
                    return true;
                }
            }
            return false;
        }
        validate_tabMedPcp() {
            if ($("#medPcpValidationSummary").val() === "Ok")
                return true;
            if ($("#MedCarrierPcpInd").val() === "0")
                return true;
            if ($("#medPcpValidationSummary").val() === "") {
                oeEmpMedPcp.validateMedPcp();
                return false;
            }
            if (oeEmpMedPcp.validateMedPcpResult()) {
                oeEmpMedPcp.validateMedPcp();
            }
            return false;
        }
        validate_tabDenPcp() {
            return true;
        }
        validate_tabReview() {
            return true;
        }
        oeEmpTabNext() {
            const currentPageTabId = kendoTab.currentPageTabId(OeEmp.oeEmpTabId);
            const valid = oeEmp[`validate_${currentPageTabId}`]();
            if (valid === true) {
                oeEmp.oeEmpTabNextProxy();
            }
        }
        oeEmpTabNextProxy() {
            const medCarrierHasPcp = ($("#MedCarrierPcpInd").length && $("#MedCarrierPcpInd").val() === "1");
            const denCarrierHasPcp = ($("#DenCarrierPcpInd").length && $("#DenCarrierPcpInd").val() === "1");
            let newDepCountInt = 0;
            const newDepCount = $("#AddedNewDepCnt").val();
            if (newDepCount) {
                newDepCountInt = Math.max(parseInt(newDepCount), 0);
            }
            if ($("#hidHasAttachedDocs").val() === "1") {
                newDepCountInt = 1;
            }
            const nextTabId = oeEmp.oeEmpTabGetPageIdByIndex(kendoTab.tabGetNextIndex(OeEmp.oeEmpTabId));
            let skipTo = "";
            switch (nextTabId) {
                case "tabDocs":
                    if (newDepCountInt <= 0) {
                        skipTo = "tabPlans";
                    }
                    break;
                case "tabMedPcp":
                    if (!medCarrierHasPcp) {
                        skipTo = !denCarrierHasPcp ? "tabReview" : "tabDenPcp";
                    }
                    break;
                case "tabDenPcp":
                    if (!denCarrierHasPcp) {
                        skipTo = "tabReview";
                    }
                    break;
            }
            if (skipTo !== "") {
                kendoTab.tabActivateByPageId(OeEmp.oeEmpTabId, skipTo);
            }
            else {
                kendoTab.tabNext(OeEmp.oeEmpTabId);
            }
        }
        oeEmpTabPrevious() {
            const medCarrierHasPcp = ($("#MedCarrierPcpInd").length && $("#MedCarrierPcpInd").val() === "1");
            const denCarrierHasPcp = ($("#DenCarrierPcpInd").length && $("#DenCarrierPcpInd").val() === "1");
            let newDepCountInt = 0;
            const newDepCount = $("#AddedNewDepCnt").val();
            if (newDepCount) {
                newDepCountInt = Math.max(parseInt(newDepCount), 0);
            }
            const priorTabId = oeEmp.oeEmpTabGetPageIdByIndex(kendoTab.tabGetPriorIndex(OeEmp.oeEmpTabId));
            var skipTo = "";
            switch (priorTabId) {
                case "tabDocs":
                    if (newDepCountInt <= 0) {
                        skipTo = "tabDep";
                    }
                    break;
                case "tabDenPcp":
                    if (!denCarrierHasPcp) {
                        skipTo = !medCarrierHasPcp ? "tabPlans" : "tabMedPcp";
                    }
                    break;
                case "tabMedPcp":
                    if (!medCarrierHasPcp) {
                        skipTo = "tabPlans";
                    }
                    break;
            }
            if (skipTo !== "") {
                kendoTab.tabActivateByPageId(OeEmp.oeEmpTabId, skipTo);
            }
            else {
                kendoTab.tabPrevious(OeEmp.oeEmpTabId);
            }
        }
        oeEmpAddedAllDependents(yesNoVal) {
            if (yesNoVal === 1) {
                oeEmp.oeEmpTabNextProxy();
            }
        }
        oeEmpAddEmailNow(yesNoVal, objectParam) {
            if (yesNoVal === 1) {
                oeEmpDemogrEdit.oeEmpDemogrEditProxy("Pri_Email");
            }
        }
        oeEmpPlanEditNow(yesNoVal, objectParam) {
            if (yesNoVal === 1) {
                oeEmpPlanEdit.oeEmpPlanEdit();
            }
        }
        oeEmpOpenWindow(empErId, erOpenEnrollId) {
            const objectParam = { empErId, erOpenEnrollId };
            kendoWin.openMainWin(AppEnums.titles.oeWinTitle, "/Employee/oeEmp", objectParam, 800);
        }
        payload() {
            return $("#hidOePayload").val();
        }
    }
    OeEmp.oeEmpTabId = `#oeEmpTabs`;
    OeEmp.oeEmpToolbarId = `#oeEmpToolbar`;
    OeEmp.empPageTabIds = ["tabEmp", "tabDep", "tabDocs", "tabPlans", "tabMedPcp", "tabDenPcp", "tabReview"];
    AresFunc.OeEmp = OeEmp;
})(AresFunc || (AresFunc = {}));
var oeEmp = new AresFunc.OeEmp();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpDemogr = "oeEmpDemogr";
    class OeEmpDemogr {
        constructor() {
            this.areaName = nameOeEmpDemogr;
        }
        oeEmpDemogrInit() {
            appPanel.panelSetState(nameOeEmpDemogr, true);
        }
    }
    AresFunc.OeEmpDemogr = OeEmpDemogr;
})(AresFunc || (AresFunc = {}));
var oeEmpDemogr = new AresFunc.OeEmpDemogr();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpDemogrEdit = "oeEmpDemogrEdit";
    class OeEmpDemogrEdit extends AresFunc.EditSaveCancelBase {
        constructor() {
            super(...arguments);
            this.areaName = nameOeEmpDemogrEdit;
            this.oeEmpDemogrEdit = () => {
                this.oeEmpDemogrEditProxy();
            };
        }
        onInit() {
            appFunc.hideWhenEmpty("#Phone_Home", "#Phone_Home_Notes_Wrapper");
            appFunc.hideWhenEmpty("#Phone_Mobile", "#Phone_Mobile_Notes_Wrapper");
            appFunc.hideWhenEmpty("#Phone_Work", "#Phone_Work_Notes_Wrapper");
            const setFocusTo = $("#SetFocusTo").val();
            appFunc.setFocus(setFocusTo);
        }
        oeEmpDemogrEditProxy(setFocusTo = "") {
            const payload = oeEmp.payload();
            const objectParam = { payload, setFocusTo };
            kendoWin.openItemWin(AppEnums.titles.oeWinTitle, `/Employee/${nameOeEmpDemogrEdit}`, objectParam, 800);
        }
        onSubmitSuccess(data) {
            kendoTab.tabReload("#oeEmpTabs");
            kendoWin.exitItemWindow();
        }
    }
    AresFunc.OeEmpDemogrEdit = OeEmpDemogrEdit;
})(AresFunc || (AresFunc = {}));
var oeEmpDemogrEdit = new AresFunc.OeEmpDemogrEdit();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpDenPcp = "oeEmpDenPcp";
    class OeEmpDenPcp {
        constructor() {
            this.areaName = nameOeEmpDenPcp;
        }
        oeEmpDenPcpInit() {
            appPanel.panelSetState(nameOeEmpDenPcp, true);
        }
        reloadOeEmpDenPcpSection(rowId) {
            $.ajax({
                url: "/DentalPcp/OeEmpDenPcpView/",
                type: "POST",
                cache: false,
                data: {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    rowId: rowId,
                    payload: oeEmp.payload()
                },
                success(result) {
                    if (result) {
                        appFunc.replaceHtml(`#denPcpRow${rowId}`, result);
                    }
                    else {
                        kendoTab.tabReload("#oeEmpTabs");
                    }
                    kendoTab.setPageTabAttribute("tabReview", "data-refresh-tab", "1");
                },
                error(result) {
                    appFunc.logJavaScriptError(result.responseText);
                }
            });
        }
    }
    AresFunc.OeEmpDenPcp = OeEmpDenPcp;
})(AresFunc || (AresFunc = {}));
var oeEmpDenPcp = new AresFunc.OeEmpDenPcp();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpDenPcpEdit = "oeEmpDenPcpEdit";
    class OeEmpDenPcpEdit extends AresFunc.EditSaveCancelBase {
        constructor() {
            super(...arguments);
            this.areaName = nameOeEmpDenPcpEdit;
        }
        onInit() {
            appFunc.setFocus("PCP_ID");
        }
        oeEmpDenPcpEdit(e) {
            const payload = oeEmp.payload();
            const rowId = $(e.target).parent().data("rowid");
            const pcpInputLength = $("#DenPcpInputLength").val();
            const objectParam = { payload, rowId, pcpInputLength };
            kendoWin.openItemWin(AppEnums.titles.oeWinTitle, `/DentalPcp/${nameOeEmpDenPcpEdit}`, objectParam, 800);
        }
        onSubmitSuccess(data) {
            if (data.rowId >= 0) {
                oeEmpDenPcp.reloadOeEmpDenPcpSection(data.rowId);
            }
            else {
                kendoTab.tabReload("#oeEmpTabs");
                kendoTab.setPageTabAttribute("tabReview", "data-refresh-tab", "1");
            }
            kendoWin.exitItemWindow();
        }
    }
    AresFunc.OeEmpDenPcpEdit = OeEmpDenPcpEdit;
})(AresFunc || (AresFunc = {}));
var oeEmpDenPcpEdit = new AresFunc.OeEmpDenPcpEdit();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpDep = "oeEmpDep";
    class SinglePlan {
        constructor() {
            this.benefitCode = "";
            this.benefitName = "";
        }
    }
    class OeEmpDep {
        constructor() {
            this.areaName = nameOeEmpDep;
        }
        oeEmpDepInit() {
            appPanel.panelSetState(nameOeEmpDep, true);
        }
        oeEmpDepRemoveAsk(e) {
            const parent = $(e.target).parent();
            const rowId = parent.data().rowid;
            const depName = $(`#idName${rowId}`).html();
            const jsonCargo = {
                rowId: rowId
            };
            kendoWin.openYesNoWin("Remove Dependent", `Remove Dependent: ${depName}?`, `${nameOeEmpDep}.oeEmpDepRemoveDo`, jsonCargo);
        }
        oeEmpDepRemoveDo(yesNoVal, objectParam) {
            if (yesNoVal === 1) {
                const newDepCount = $("#AddedNewDepCnt").val();
                var newDepCountInt = Math.max(parseInt(newDepCount), 0);
                $.ajax({
                    url: "/Employee/OeEmpDepRemove/",
                    type: "POST",
                    cache: false,
                    data: {
                        __RequestVerificationToken: appFunc.getVerificationToken(),
                        rowId: objectParam.rowId,
                        payload: oeEmp.payload()
                    },
                    success(result) {
                        if (result.success) {
                            if (result.spouseRemoved) {
                                kendoTab.tabReload("#oeEmpTabs");
                            }
                            else {
                                $(`#depRow${objectParam.rowId}`).html("");
                                newDepCountInt = Math.max(newDepCountInt - 1, 0);
                                $("#AddedNewDepCnt").val(newDepCountInt);
                            }
                            oeEmp.setReloadTabs();
                        }
                        else {
                            if (result.message !== "") {
                                kendoWin.openInfoWin("Alert", `Remove Failed! - ${result.message}`);
                            }
                            else {
                                alert("Remove Failed!");
                            }
                        }
                    },
                    error(result) {
                        appFunc.logJavaScriptError(result.responseText);
                    }
                });
            }
        }
        oeEmpDepIncludeExclude(e) {
            const parent = $(e.target).parent();
            const rowId = parent.data().rowid;
            const med = $(`#idMed${rowId}`);
            const den = $(`#idDen${rowId}`);
            const vis = $(`#idVis${rowId}`);
            const medVal = med.val();
            const denVal = den.val();
            const visVal = vis.val();
            const singlePlan = oeEmpDep.getSinglePlan(medVal, denVal, visVal);
            if (singlePlan.benefitCode !== "") {
                let actionName = "Include";
                if (singlePlan.benefitCode === singlePlan.benefitCode.toUpperCase()) {
                    actionName = "Exclude";
                }
                const jsonCargo = {
                    rowId: rowId,
                    benefitCode: singlePlan.benefitCode,
                    benefitName: singlePlan.benefitName,
                    actionName: actionName
                };
                if (actionName === "Include") {
                    kendoWin.openYesNoWin("Include dependent in benefit", (`Include dependent in ${singlePlan.benefitName} benefits`), `${nameOeEmpDep}.oeEmpDepIncludeExcludePlan`, jsonCargo);
                }
                else {
                    kendoWin.openYesNoWin("Exclude dependent from benefit", (`Exclude dependent from ${singlePlan.benefitName} benefits`), `${nameOeEmpDep}.oeEmpDepIncludeExcludePlan`, jsonCargo);
                }
            }
            else {
                oeEmpDepDemogrEdit.oeEmpDepDemogrEdit(e);
            }
            return;
        }
        oeEmpDepIncludeExcludePlan(yesNoVal, objectParam) {
            if (yesNoVal === 1) {
                $.ajax({
                    url: "/Employee/OeEmpDepIncludeExcludeSinglePlan/",
                    type: "POST",
                    cache: false,
                    data: {
                        __RequestVerificationToken: appFunc.getVerificationToken(),
                        rowId: objectParam.rowId,
                        benefitCode: objectParam.benefitName,
                        actionName: objectParam.actionName,
                        payload: oeEmp.payload()
                    },
                    success(result) {
                        if (result.success) {
                            oeEmpDep.reloadOeEmpDepSection(objectParam.rowId);
                        }
                        else {
                            alert("Action Failed!");
                        }
                    },
                    error(result) {
                        appFunc.logJavaScriptError(result.responseText);
                    }
                });
            }
        }
        reloadOeEmpDepSection(rowId) {
            $.ajax({
                url: "/Employee/OeEmpDepGetOne/",
                type: "POST",
                cache: false,
                data: {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    rowId: rowId,
                    payload: oeEmp.payload()
                },
                success(result) {
                    if (result) {
                        appFunc.replaceHtml(`#depRow${rowId}`, result);
                    }
                    else {
                        kendoTab.tabReload("#oeEmpTabs");
                    }
                    oeEmp.setReloadTabs();
                },
                error(result) {
                    appFunc.logJavaScriptError(result.responseText);
                }
            });
        }
        getSinglePlan(medVal, denVal, visVal) {
            const medCode = medVal.toUpperCase();
            const denCode = denVal.toUpperCase();
            const visCode = visVal.toUpperCase();
            const hasMed = medCode === "M";
            const hasDen = denCode === "D";
            const hasVis = visCode === "V";
            const singlePlan = new SinglePlan;
            if (hasMed && !(hasDen || hasVis)) {
                singlePlan.benefitName = "Medical";
                singlePlan.benefitCode = medVal;
            }
            if (hasDen && !(hasMed || hasVis)) {
                singlePlan.benefitName = "Dental";
                singlePlan.benefitCode = denVal;
            }
            if (hasVis && !(hasMed || hasDen)) {
                singlePlan.benefitName = "Vision";
                singlePlan.benefitCode = visVal;
            }
            return singlePlan;
        }
    }
    AresFunc.OeEmpDep = OeEmpDep;
})(AresFunc || (AresFunc = {}));
var oeEmpDep = new AresFunc.OeEmpDep();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpDepDemogrEdit = "oeEmpDepDemogrEdit";
    class SinglePlan {
    }
    class OeEmpDepDemogrEdit extends AresFunc.EditSaveCancelBase {
        constructor() {
            super(...arguments);
            this.areaName = nameOeEmpDepDemogrEdit;
        }
        onInit() {
            appFunc.hideWhenEmpty("#Phone_Home", "#Phone_Home_Notes_Wrapper");
            appFunc.hideWhenEmpty("#Phone_Mobile", "#Phone_Mobile_Notes_Wrapper");
            appFunc.hideWhenEmpty("#Phone_Work", "#Phone_Work_Notes_Wrapper");
        }
        oeEmpDepAdd() {
            const payload = oeEmp.payload();
            const rowId = 0;
            const objectParam = { payload, rowId };
            const url = `/Employee/${nameOeEmpDepDemogrEdit}`;
            kendoWin.openItemWin(AppEnums.titles.oeWinTitle, url, objectParam, 800);
        }
        oeEmpDepDemogrEdit(e) {
            const payload = oeEmp.payload();
            const rowId = $(e.target).parent().data("rowid");
            const objectParam = { payload, rowId };
            const url = `/Employee/${nameOeEmpDepDemogrEdit}`;
            kendoWin.openItemWin(AppEnums.titles.oeWinTitle, url, objectParam, 800);
        }
        onOeEmpDepUseSubscriberAddr(e) {
            $("#Street_Addr").closest("tr").toggle();
            $("#Apt_Suite").closest("tr").toggle();
            $("#City").closest("tr").toggle();
            $("#State").closest("tr").toggle();
            $("#Zip_Code").closest("tr").toggle();
            appFunc.setFocus("#Street_Addr");
        }
        beforeSubmit() {
            const formName = `#${nameOeEmpDepDemogrEdit}Form`;
            const formRef = $(formName);
            formRef.validate();
            const isValid = formRef.valid();
            if ($("#Dep_ID").val() <= 0 && isValid) {
                return true;
            }
            if (isValid) {
                let changes = "";
                let changeCount = 0;
                const firstName = $("#First_Name").val().toLowerCase();
                const sFirstName = $("#s_First_Name").val().toLowerCase();
                const lastName = $("#Last_Name").val().toLowerCase();
                const sLastName = $("#s_Last_Name").val().toLowerCase();
                const birthdate = $("#Birthdate").val();
                const sBirthdate = $("#s_Birthdate_Display").val();
                if (firstName !== sFirstName) {
                    changes += "First name changed";
                    changeCount++;
                }
                if (lastName !== sLastName) {
                    if (changeCount > 0)
                        changes += ", ";
                    changes += "Last name changed";
                    changeCount++;
                }
                if (birthdate !== sBirthdate) {
                    if (changeCount > 0)
                        changes += ", ";
                    changes += "Birth-date changed";
                    changeCount++;
                }
                if (changeCount > 1) {
                    kendoWin.openYesNoWin("Multiple identification changes", `You have made multiple changes:\n${changes}<br /><br />If you are adding a new dependent, select "No" then cancel your changes and use the Add button to add a new dependent, if you want to commit the changes select "Yes"`, `${nameOeEmpDepDemogrEdit}.acceptChanges`, null, 500, 320);
                    return false;
                }
                else {
                    return true;
                }
            }
        }
        acceptChanges(yesNoVal) {
            if (yesNoVal === 1) {
                $(`#${nameOeEmpDepDemogrEdit}Form`).submit();
            }
        }
        onSubmitSuccess(data) {
            if (data.rowId > 0) {
                oeEmpDep.reloadOeEmpDepSection(data.rowId);
            }
            else {
                kendoTab.tabReload("#oeEmpTabs");
            }
            oeEmp.setReloadTabs();
            kendoWin.exitItemWindow();
        }
    }
    AresFunc.OeEmpDepDemogrEdit = OeEmpDepDemogrEdit;
})(AresFunc || (AresFunc = {}));
var oeEmpDepDemogrEdit = new AresFunc.OeEmpDepDemogrEdit();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpDoc = "oeEmpDoc";
    class SinglePlan {
    }
    class OeEmpDoc {
        constructor() {
            this.areaName = nameOeEmpDoc;
        }
        oeEmpDocInit() {
            appPanel.panelSetState(nameOeEmpDoc, true);
        }
        oeEmpDocDeleteAsk(e) {
            const parent = $(e.target).parent();
            const rowId = parent.data().rowid;
            const fileName = $(`#idDocName${rowId}`).html();
            const jsonCargo = {
                rowId: rowId
            };
            kendoWin.openYesNoWin("Delete Document", `Delete Document: ${fileName}?`, "oeEmpDoc.oeEmpDocDeleteDo", jsonCargo);
        }
        oeEmpDocDeleteDo(yesNoVal, objectParam) {
            if (yesNoVal === 1) {
                const docCount = $("#AddedDocCnt").val();
                var docCountInt = Math.max(parseInt(docCount), 0);
                $.ajax({
                    url: "/Employee/OeEmpDocDelete/",
                    type: "POST",
                    cache: false,
                    data: {
                        __RequestVerificationToken: appFunc.getVerificationToken(),
                        rowId: objectParam.rowId,
                        payload: oeEmp.payload()
                    },
                    success(result) {
                        if (result.success) {
                            $(`#docRow${objectParam.rowId}`).html("");
                            kendoTab.setPageTabAttribute("tabReview", "data-refresh-tab", "1");
                            docCountInt = Math.max(docCountInt - 1, 0);
                            $("#AddedDocCnt").val(docCountInt);
                            if (docCountInt === 0) {
                                $("#hidHasAttachedDocs").val("0");
                            }
                        }
                        else {
                            if (result.message !== "") {
                                kendoWin.openInfoWin("Alert", `Delete Failed! - ${result.message}`);
                            }
                            else {
                                alert("Delete Failed!");
                            }
                        }
                    },
                    error(result) {
                        appFunc.logJavaScriptError(result.responseText);
                    }
                });
            }
        }
        reloadOeEmpDocSection(rowId) {
            $.ajax({
                url: "/Employee/OeEmpDocGetOne/",
                type: "POST",
                cache: false,
                data: {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    rowId: rowId,
                    payload: oeEmp.payload()
                },
                success(result) {
                    if (result) {
                        appFunc.replaceHtml(`#docRow${rowId}`, result);
                    }
                    else {
                        kendoTab.tabReload("#oeEmpTabs");
                    }
                    kendoTab.setPageTabAttribute("tabReview", "data-refresh-tab", "1");
                },
                error(result) {
                    appFunc.logJavaScriptError(result.responseText);
                }
            });
        }
    }
    AresFunc.OeEmpDoc = OeEmpDoc;
})(AresFunc || (AresFunc = {}));
var oeEmpDoc = new AresFunc.OeEmpDoc();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpDocEditArea = "oeEmpDocEdit";
    class OeEmpDocEdit extends AresFunc.EditSaveCancelBase {
        constructor() {
            super(...arguments);
            this.areaName = nameOeEmpDocEditArea;
        }
        onInit() {
        }
        oeEmpDocAdd() {
            const payload = oeEmp.payload();
            const rowId = 0;
            const objectParam = { payload, rowId };
            kendoWin.openItemWin(AppEnums.titles.oeWinTitle, `/Employee/${nameOeEmpDocEditArea}`, objectParam, 800);
        }
        oeEmpDocEdit(e) {
            const payload = oeEmp.payload();
            const rowId = $(e.target).parent().data("rowid");
            const objectParam = { payload, rowId };
            kendoWin.openItemWin(AppEnums.titles.oeWinTitle, `/Employee/${nameOeEmpDocEditArea}`, objectParam, 800);
        }
        beforeSubmit() {
            const formName = `#${nameOeEmpDocEditArea}Form`;
            const formRef = $(formName);
            formRef.validate();
            const isValid = formRef.valid();
            if ($("#Emp_Request_ER_Doc_ID").val() > 0) {
                return true;
            }
            else {
                if ($("#DocAddedInd").val() == 0) {
                    $("#DocRequiredMsg").show();
                    return false;
                }
                if (isValid) {
                    $(".k-upload-selected").click();
                    return false;
                }
            }
            return false;
        }
        fileCheck(validationErrors) {
            const fileSize = $("#DocAddedSize").val();
            const maxSizeMb = 20971520;
            if (fileSize > maxSizeMb) {
                kendoWin.openInfoWin("Alert", "Document size cannot exceed 20 MB!");
                return false;
            }
            if ((validationErrors ?? []).indexOf("invalidFileExtension") >= 0) {
                kendoWin.openInfoWin("Alert", "This type of document cannot be uploaded. Please upload a PDF, a picture or a Word document.");
                return false;
            }
            return true;
        }
        fileSelect(e) {
            kendoWin.dataChanged();
            let fileOkay = true;
            $.each(e.files, (index, value) => {
                $("#DocAddedSize").val(value.size);
                $("#DocAddedExt").val(value.extension);
                if (oeEmpDocEdit.fileCheck(value.validationErrors) === false) {
                    fileOkay = false;
                }
            });
            if (!fileOkay) {
                e.preventDefault();
                return;
            }
            setTimeout(() => {
                $("#DocAddedInd").val(1);
                $("#DocRequiredMsg").hide("fast");
            }, 100);
        }
        fileUpload(e) {
            oeEmpDocEdit.toolbarState(false);
            const docDescription = $("#Emp_Request_ER_Doc_Desc").val();
            const docNotes = $("#Emp_Request_ER_Doc_Note").val();
            const payload = $("#Payload").val();
            const categoryId = $("#L_Emp_Request_ER_Doc_Cat_ID").data("kendoDropDownList").value();
            e.data = {
                docDescription: docDescription,
                docNotes: docNotes,
                categoryId: categoryId,
                payload: payload
            };
        }
        fileSuccess(e) {
            oeEmpDocEdit.toolbarState(true);
            kendoWin.exitItemWindow();
            kendoTab.tabReload("#oeEmpTabs");
        }
        fileError(e) {
            oeEmpDocEdit.toolbarState(true);
            const request = e.XMLHttpRequest;
            const responseText = request.responseText;
            if (request.status === 200 && responseText && (request.getResponseHeader("Content-Type") ?? "").indexOf("text/plain") === 0) {
                kendoWin.openInfoWin("Alert", responseText);
                return;
            }
            appFunc.logJavaScriptError(e.operation + " | " + responseText);
        }
        fileComplete(e) {
            oeEmpDocEdit.toolbarState(true);
            kendoWin.dataChanged();
        }
        fileCancel(e) {
            oeEmpDocEdit.toolbarState(true);
        }
        fileRemove(e) {
            $("#DocAddedInd").val(0);
            $("#DocRequiredMsg").show();
        }
        onToolbarStateChanged(enableDisable) {
            if (enableDisable) {
                appFunc.progressHide();
            }
            else {
                appFunc.progressShow();
            }
            const fileUpload = $("#DocAttachment").data("kendoUpload");
            if (fileUpload) {
                if (enableDisable) {
                    fileUpload.enable();
                }
                else {
                    fileUpload.disable();
                }
            }
        }
        onSubmitSuccess(data) {
            if (data.rowId > 0) {
                oeEmpDoc.reloadOeEmpDocSection(data.rowId);
            }
            else {
                kendoTab.tabReload("#oeEmpTabs");
                kendoTab.setPageTabAttribute("tabReview", "data-refresh-tab", "1");
            }
            kendoWin.exitItemWindow();
        }
    }
    AresFunc.OeEmpDocEdit = OeEmpDocEdit;
})(AresFunc || (AresFunc = {}));
var oeEmpDocEdit = new AresFunc.OeEmpDocEdit();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpLogin = "oeEmpLogin";
    class OeEmpLogin extends AresFunc.EditSaveCancelBase {
        constructor() {
            super(...arguments);
            this.areaName = nameOeEmpLogin;
        }
        onInit() {
            appFunc.setFocus("#Username");
        }
        onSubmitSuccess(data) {
            document.location.replace("/Employee/Info");
        }
        toolbarState(enableDisable) {
        }
    }
    AresFunc.OeEmpLogin = OeEmpLogin;
})(AresFunc || (AresFunc = {}));
var oeEmpLogin = new AresFunc.OeEmpLogin();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpMedPcp = "oeEmpMedPcp";
    class OeEmpMedPcp {
        constructor() {
            this.areaName = nameOeEmpMedPcp;
        }
        init() {
            appPanel.panelSetState(nameOeEmpMedPcp, true);
        }
        reloadOeEmpMedPcpSection(rowId) {
            $.ajax({
                url: "/MedicalPcp/OeEmpMedPcpView/",
                type: "POST",
                cache: false,
                data: {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    rowId: rowId,
                    payload: oeEmp.payload()
                },
                success(result) {
                    if (result) {
                        appFunc.replaceHtml(`#medPcpRow${rowId}`, result);
                        $("#medPcpValidationSummary").val("");
                    }
                    else {
                        kendoTab.tabReload("#oeEmpTabs");
                    }
                    kendoTab.setPageTabAttribute("tabReview", "data-refresh-tab", "1");
                },
                error(result) {
                    appFunc.logJavaScriptError(result.responseText);
                }
            });
        }
        acceptPcp(yesNoVal) {
            if (yesNoVal !== 1) {
                return;
            }
            oeEmp.oeEmpTabNextProxy();
        }
        validateMedPcp() {
            $.ajax({
                url: "/MedicalPcp/OeEmpMedPcpValidate/",
                type: "POST",
                cache: false,
                data: {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    payload: oeEmp.payload()
                },
                success(result) {
                    if (result) {
                        appFunc.replaceHtml(`#${nameOeEmpMedPcp}ListContainer`, result);
                        if (oeEmpMedPcp.validateMedPcpResult()) {
                            oeEmp.oeEmpTabNextProxy();
                        }
                    }
                    else {
                        kendoWin.openInfoWin("PCP Validation Error", "Unable to validate PCP!");
                    }
                },
                error(result) {
                    appFunc.logJavaScriptError(result.responseText);
                }
            });
        }
        validateMedPcpResult() {
            const pcpValidationSummary = $("#medPcpValidationSummary").val();
            if (pcpValidationSummary.toLowerCase().indexOf("invalid") >= 0) {
                kendoWin.openInfoWin("PCP Validation", "One or more PCP(s) not found (indicated in red and crossed out) in the Performance Network.<br/><br/><strong>Possible reasons</strong>: You changed your Performance Network, your home address changed or the physician is no longer available.<br/><br/>Please correct the invalid PCP(s) and try again.", 500, 250);
                return false;
            }
            var pcpWarning = "";
            var pcpMessageHeight = 220;
            if (pcpValidationSummary.toLowerCase().indexOf("unknown") >= 0) {
                const noValidateMsg = "<strong>Error</strong>: One or more PCP(s) cannot be validated in the Performance Network. " +
                    "<strong>Possible reasons</strong>: The online lookup is currently unavailable, or the lookup timed out.<br/><br/>" +
                    "Please try again later, or continue. <strong>Attention</strong>: If you chose to continue the PCP may <strong>not</strong> be accepted by the carrier<br/><br/>";
                pcpMessageHeight += 130;
                pcpWarning += noValidateMsg;
            }
            if (pcpValidationSummary.toLowerCase().indexOf("manual") >= 0) {
                pcpMessageHeight += 70;
                pcpWarning += "<strong>Note:</strong> One or more PCP(s) were entered manually; manually entered PCP's cannot be validated and may <strong>not</strong> be accepted by the carrier.<br/><br/><br/>";
            }
            if ($("#medPcpEmptyCount").val() > 0) {
                if ($("#medPcpPlanChanged").val() === "1") {
                    pcpMessageHeight += 80;
                    pcpWarning += "One or more members do not have a PCP assigned.<br/><br/><strong>Note:</strong> Members with unassigned PCP will have a PCP auto-assigned to them by the carrier.<br/><br/><br/>";
                }
                else {
                    pcpMessageHeight += 35;
                    pcpWarning += "One or more members do not have a PCP assigned.<br/><br/><br/>";
                }
            }
            if (pcpWarning !== "") {
                pcpWarning += "Continue?";
                kendoWin.openYesNoWin("PCP Alert", pcpWarning, "oeEmpMedPcp.acceptPcp", null, 500, pcpMessageHeight);
                return false;
            }
            $("#medPcpValidationSummary").val("Ok");
            return true;
        }
        unableValidatePcpContinue(yesNoVal) {
            if (yesNoVal !== 1) {
                return;
            }
            $("#medPcpValidationSummary").val("Ok");
        }
    }
    AresFunc.OeEmpMedPcp = OeEmpMedPcp;
})(AresFunc || (AresFunc = {}));
var oeEmpMedPcp = new AresFunc.OeEmpMedPcp();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpMedPcpEditArea = "oeEmpMedPcpEdit";
    class OeEmpMedPcpEdit extends AresFunc.EditSaveCancelBase {
        constructor() {
            super(...arguments);
            this.areaName = nameOeEmpMedPcpEditArea;
        }
        init() {
            $("#PCP_ID, #PCP_Name").on("input", kendoWin.dataChanged);
            if ($("#PCP_Manual").val() === "True") {
                appFunc.setFocus("#PCP_ID");
            }
            else {
                appFunc.setFocus("#LookupPcpLastName");
            }
            const pcpId = $.trim($("#PCP_ID").val());
            const pcpName = $.trim($("#PCP_Name").val());
            if (pcpId !== "" || pcpName !== "") {
                $("#removeMedPcpBtn").show();
            }
        }
        onInit() {
        }
        oeEmpMedPcpEdit(e) {
            const payload = oeEmp.payload();
            const rowId = $(e.target).parent().data("rowid");
            const pcpInputLength = $("#MedPcpInputLength").val();
            const objectParam = { payload, rowId, pcpInputLength };
            kendoWin.openItemWin(AppEnums.titles.oeWinTitle, `/MedicalPcp/${nameOeEmpMedPcpEditArea}`, objectParam, 800);
        }
        pcpWindowResized() {
            let gridHeight = $("#oeEmpMedPcpEditContainer").innerHeight() - 440;
            if (gridHeight > 150) {
                $("#pcpList").height(gridHeight);
                kendoGrid.gridResize("pcpList");
            }
        }
        onSubmitSuccess(data) {
            if (data.rowId >= 0) {
                oeEmpMedPcp.reloadOeEmpMedPcpSection(data.rowId);
            }
            else {
                kendoTab.tabReload("#oeEmpTabs");
                kendoTab.setPageTabAttribute("tabReview", "data-refresh-tab", "1");
            }
            kendoWin.exitItemWindow();
        }
        searchPcp() {
            const formName = `#${nameOeEmpMedPcpEditArea}Form`;
            const formRef = $(formName);
            formRef.validate();
            const isValid = formRef.valid();
            if (!isValid)
                return;
            const lastName = $.trim($("#LookupPcpLastName").val());
            const firstName = $.trim($("#LookupPcpFirstName").val());
            const memberMedPcpPayload = $("#MemberMedPcpPayload").val();
            if ((lastName + firstName).length < 1) {
                kendoWin.openInfoWin("Search Criterion Required", "Please enter a search criterion first - (PCP Last Name, First Name or both that begins with)");
                return;
            }
            $("#MedPcpProviderContainer").html("<div class='please-wait-colored'>Please wait looking up PCPs...<div>");
            $.ajax({
                url: "/MedicalPcp/OeEmpMedPcpLookup/",
                type: "POST",
                cache: false,
                data: {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    payload: oeEmp.payload(),
                    lastName: lastName,
                    firstName: firstName,
                    memberMedPcpPayload: memberMedPcpPayload
                },
                success(result) {
                    if (result) {
                        $("#MedPcpProviderContainer").html(result);
                    }
                    kendoTab.setPageTabAttribute("tabReview", "data-refresh-tab", "1");
                },
                error(result) {
                    $("#MedPcpProviderContainer").html("<div class='warning-colored'>An error occurred searching PCP, please try again later<div>");
                    appFunc.logJavaScriptError(result.responseText);
                }
            });
        }
        selectPcp(e) {
            const currentDataItem = kendoGrid.getGridDataItem(e);
            let pcpNumber = currentDataItem.MedicalGroupPcp;
            let pcpName = currentDataItem.PcpName;
            $("#PCP_ID").val(pcpNumber);
            $("#PCP_Name").val(pcpName);
            $("#PCP_Manual").val("False");
            $(`#${nameOeEmpMedPcpEditArea}Container`).animate({ scrollTop: 0 }, 100);
            $("#PCP_Name_Display").hide().html(`${pcpName}<br/>${pcpNumber}`).fadeIn(1000);
            kendoWin.dataChanged();
            $("#removeMedPcpBtn").show();
        }
        accountOpenOnDoubleClick() {
            const gridId = "#pcpList";
            $(gridId).off("dblclick", " tbody > tr");
            $(gridId).on("dblclick", " tbody > tr", e => {
                var grid = $(gridId).data("kendoGrid");
                oeEmpMedPcpEdit.selectPcp(grid.select());
                e.preventDefault();
                return false;
            });
        }
        removePcpAsk() {
            kendoWin.openYesNoWin("Remove PCP", "Are you sure you want to remove this PCP?", `${nameOeEmpMedPcpEditArea}.removePcp`);
        }
        removePcp(yesNoVal) {
            if (yesNoVal !== 1) {
                return;
            }
            $("#PCP_ID").val("");
            $("#PCP_Name").val("");
            $("#PCP_Name_Display").hide().html("").fadeIn("slow");
            $("#removeMedPcpBtn").hide();
            kendoWin.dataChanged();
        }
        manualPcpAsk() {
            kendoWin.openYesNoWin("Enter PCP Manually", "Are you sure you want enter the PCP manually?<br /><br />Note: Manually inputted PCP cannot be validated and may not be accepted by the carrier", `${nameOeEmpMedPcpEditArea}.manualPcp`);
        }
        manualPcp(yesNoVal) {
            if (yesNoVal !== 1) {
                return;
            }
            $("#PCP_ID").val("");
            $("#PCP_Name").val("");
            $("#PCP_Manual").val("True");
            $("#PCP_Name_Display").hide().html("").fadeIn("slow");
            $("#removeMedPcpBtn").hide();
            $("#medPcpSearchDiv").hide();
            $("#manualMedPcpDiv").show();
            appFunc.setFocus("PCP_ID");
            kendoWin.dataChanged();
        }
        resetManualPcpAsk() {
            kendoWin.openYesNoWin("Reset Manual PCP", "Are you sure you want to reset adding the PCP manually?", `${nameOeEmpMedPcpEditArea}.resetManualPcp`);
        }
        resetManualPcp(yesNoVal) {
            if (yesNoVal !== 1) {
                return;
            }
            $("#PCP_ID").val("");
            $("#PCP_Name").val("");
            $("#PCP_Manual").val("False");
            $("#PCP_Name_Display").hide().html("").fadeIn("slow");
            $("#removeMedPcpBtn").hide();
            $("#manualMedPcpDiv").hide();
            $("#medPcpSearchDiv").show();
            appFunc.setFocus("LookupPcpLastName");
            kendoWin.dataChanged();
        }
    }
    AresFunc.OeEmpMedPcpEdit = OeEmpMedPcpEdit;
})(AresFunc || (AresFunc = {}));
var oeEmpMedPcpEdit = new AresFunc.OeEmpMedPcpEdit();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpPinArea = "oeEmpPin";
    const newPasswordFields = "#NewPassword, #ConfirmPassword";
    class OeEmpPin extends AresFunc.EditSaveCancelBase {
        constructor() {
            super(...arguments);
            this.areaName = nameOeEmpPinArea;
        }
        onInit() {
            $(newPasswordFields).attr("autocomplete", "new-password");
            appFunc.setFocus("#SubscriberSsn");
        }
        onSubmitSuccess(data) {
            if (data.login === true) {
                $("#oeEmpLoginForm #Username").val(data.pin);
                $("#oeEmpLoginForm #Password").val($("#NewPassword").val());
                $("#oeEmpLoginForm").submit();
                kendoWin.exitItemWindow();
            }
            else {
                $("#EmpPin").val(data.pin);
                $("#PinPayload").val(data.pinPayload);
                $(newPasswordFields).prop("disabled", false).removeClass("k-disabled").val("");
                $("#empPinDisplay").html(data.pin);
                $("#empName").html(data.subscriberName);
                $("#oeEmpPinDiv").hide();
                $("#oeEmpPinPswd").show();
                appFunc.setFocus("#NewPassword");
                if (data.isVebaMember === true) {
                    $("#IsVebaMemberMessage").show();
                }
            }
        }
        subscriberPin(buttonSource) {
            const objectParam = { buttonSource };
            kendoWin.openItemWin(AppEnums.titles.getPinTitile, "/Account/SubscriberPin", objectParam, 700, 0, false);
        }
    }
    AresFunc.OeEmpPin = OeEmpPin;
})(AresFunc || (AresFunc = {}));
var oeEmpPin = new AresFunc.OeEmpPin();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpPlan = "oeEmpPlan";
    class OeEmpPlan {
        constructor() {
            this.areaName = nameOeEmpPlan;
        }
        oeEmpPlanInit() {
            appPanel.panelSetState(nameOeEmpPlan, true);
        }
    }
    AresFunc.OeEmpPlan = OeEmpPlan;
})(AresFunc || (AresFunc = {}));
var oeEmpPlan = new AresFunc.OeEmpPlan();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpPlanEdit = "oeEmpPlanEdit";
    class OeEmpPlanEdit extends AresFunc.EditSaveCancelBase {
        constructor() {
            super(...arguments);
            this.areaName = nameOeEmpPlanEdit;
        }
        onInit() {
            const setFocusTo = $("#SetFocusTo").val();
            appFunc.setFocus(setFocusTo);
        }
        oeEmpPlanEdit() {
            const payload = oeEmp.payload();
            const objectParam = { payload };
            kendoWin.openItemWin(AppEnums.titles.oeWinTitle, `/Employee/${nameOeEmpPlanEdit}`, objectParam, 800);
        }
        onSubmitSuccess(data) {
            kendoTab.setPageTabAttribute("tabMedPcp", "data-refresh-tab", "1");
            kendoTab.setPageTabAttribute("tabDenPcp", "data-refresh-tab", "1");
            kendoTab.setPageTabAttribute("tabReview", "data-refresh-tab", "1");
            kendoTab.tabReload("#oeEmpTabs");
            kendoWin.exitItemWindow();
        }
    }
    AresFunc.OeEmpPlanEdit = OeEmpPlanEdit;
})(AresFunc || (AresFunc = {}));
var oeEmpPlanEdit = new AresFunc.OeEmpPlanEdit();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpPswdArea = "oeEmpPswd";
    class OeEmpPswd extends AresFunc.EditSaveCancelBase {
        constructor() {
            super(...arguments);
            this.areaName = nameOeEmpPswdArea;
        }
        onInit() {
            appFunc.setFocus("#CurrentPassword");
        }
        onSubmitSuccess(data) {
            kendoWin.exitItemWindow();
            kendoWin.openInfoWin("Alert", "Password changed successfully");
        }
        empChangePswd() {
            const objectParam = null;
            kendoWin.openItemWin("Change Password", "/Employee/ChangePassword", objectParam, 700, 420);
        }
    }
    AresFunc.OeEmpPswd = OeEmpPswd;
})(AresFunc || (AresFunc = {}));
var oeEmpPswd = new AresFunc.OeEmpPswd();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpSummary = "oeEmpSummary";
    class OeEmpSummary {
        constructor() {
            this.areaName = nameOeEmpSummary;
        }
        init() {
            appPanel.panelSetState(nameOeEmpSummary, true);
        }
        oeEmpSummaryConfirm() {
            const payload = oeEmp.payload();
            const objectParam = { payload };
            kendoWin.openItemWin(AppEnums.titles.oeWinTitle, `/Employee/ApplicationConfirm`, objectParam, 800);
        }
        printAppSummary() {
            appFunc.outputPrint("Print Application Summary", "oeEmpSummaryContainer");
        }
    }
    AresFunc.OeEmpSummary = OeEmpSummary;
})(AresFunc || (AresFunc = {}));
var oeEmpSummary = new AresFunc.OeEmpSummary();
var AresFunc;
(function (AresFunc) {
    const nameOeEmpSummaryConfirm = "oeEmpSummaryConfirm";
    class OeEmpSummaryConfirm {
        constructor() {
            this.areaName = nameOeEmpSummaryConfirm;
        }
        init() {
            appPanel.panelSetState(nameOeEmpSummaryConfirm, true);
        }
        submit() {
            let checkedMessage = "";
            const gotoCheckBox = "";
            if (!$("#ReviewedApplicationInd").prop('checked')) {
                checkedMessage += "<li>You must confirm that you have reviewed the <strong>submission data</strong></li>";
            }
            if ($("#ReadErTermsInd").val() < "2" && !$("#ReadErTermsInd").prop('checked')) {
                checkedMessage += "<li>You must confirm that you have read the <strong>terms of participation</strong></li>";
            }
            if ($("#ReadArbitrationInd").val() < "2" && !$("#ReadArbitrationInd").prop('checked')) {
                checkedMessage += "<li>You must confirm that you have read the <strong>arbitration agreement</strong></li>";
            }
            if (checkedMessage != "") {
                kendoWin.openInfoWin("Must acknowledge", `<ul>${checkedMessage}</ul>`, 500, 265);
                return;
            }
            const openEnrollId = $("#hidErOpenEnrollId").val();
            $.ajax({
                url: "/Employee/OeEmpSubmit/",
                type: "POST",
                cache: false,
                data: {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    payload: oeEmp.payload(),
                    openEnrollId: openEnrollId,
                    reviewedApplication: $("#ReviewedApplicationInd").prop("checked") === true,
                    readErTerms: $("#ReadErTermsInd").prop("checked") === true,
                    readArbitration: $("#ReadArbitrationInd").prop("checked") === true
                },
                success(result) {
                    if (result.success) {
                        oeEmp.oeEmpOpenWindow(result.empErId, result.erOpenEnrollId);
                        kendoWin.closeItemWindow();
                        $(`#enrollButtonLabel${result.empErId}`).html("View Open Enrollment Application");
                    }
                    else {
                        kendoWin.openInfoWin("Alert", result.message || "Submission Failed!");
                    }
                },
                error(result) {
                    kendoWin.closeMainWindow();
                    kendoWin.closeItemWindow();
                    appFunc.logJavaScriptError(result.responseText);
                }
            });
        }
    }
    AresFunc.OeEmpSummaryConfirm = OeEmpSummaryConfirm;
})(AresFunc || (AresFunc = {}));
var oeEmpSummaryConfirm = new AresFunc.OeEmpSummaryConfirm();
var AppFunc;
(function (AppFunc) {
    class DateFunc {
        getLocaleUsDateString(date) {
            if (date)
                return new Date(date).toLocaleDateString("en-US", { month: "2-digit", year: "numeric", day: "2-digit" });
        }
        formatDateToMMMYYYY(date) {
            if (date)
                return new Date(date).toLocaleDateString("en-US", { year: "numeric", month: "short" });
        }
        dateToYYYYMMDD(date) {
            if (date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var formattedMonth = month < 10 ? "0" + month : month;
                var formattedDay = day < 10 ? "0" + day : day;
                return `${year}-${formattedMonth}-${formattedDay}`;
            }
            else {
                return "";
            }
        }
        parseDate(dateString) {
            if (dateString) {
                return kendo.parseDate(dateString, "MM/dd/yyyy");
            }
            ;
            return null;
        }
        isValidDate(date) {
            const parsedDate = Date.parse(date);
            if (isNaN(date) && !isNaN(parsedDate)) {
                return true;
            }
            else {
                return false;
            }
        }
        isDateInput(event) {
            const target = event.target;
            var char = String.fromCharCode(event.which);
            let input = target.value;
            if (event.keyCode === 8 || event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 36 || event.keyCode === 35) {
                return true;
            }
            let cursorPos = event.target.selectionStart;
            let selectionEnd = event.target.selectionEnd;
            if (cursorPos !== selectionEnd) {
                input = input.substring(0, cursorPos) + input.substring(selectionEnd);
            }
            let parts = input.split("/");
            let digitCount = input.replace(/\D/g, "").length;
            if (/\d/.test(char)) {
                if (digitCount < 8) {
                    if (parts.length === 1) {
                        if (parts[0].length < 2) {
                            return true;
                        }
                        else if (parts[0].length === 2 && char !== "/") {
                            event.target.value += "/";
                            return true;
                        }
                    }
                    else if (parts.length === 2) {
                        let monthPart = parts[0];
                        let dayPart = parts[1];
                        if (cursorPos <= monthPart.length) {
                            if (monthPart.length < 2) {
                                return true;
                            }
                        }
                        else if (cursorPos > monthPart.length) {
                            if (dayPart.length < 2) {
                                return true;
                            }
                            else if (dayPart.length === 2 && char !== "/") {
                                event.target.value += "/";
                                return true;
                            }
                        }
                    }
                    else if (parts.length === 3) {
                        let monthPart = parts[0];
                        let dayPart = parts[1];
                        let yearPart = parts[2];
                        if (cursorPos <= monthPart.length) {
                            if (monthPart.length < 2) {
                                return true;
                            }
                        }
                        else if (cursorPos > monthPart.length && cursorPos <= monthPart.length + dayPart.length + 1) {
                            if (dayPart.length < 2) {
                                return true;
                            }
                        }
                        else if (cursorPos > monthPart.length + dayPart.length + 1) {
                            if (yearPart.length < 4) {
                                return true;
                            }
                        }
                    }
                }
            }
            if (char === "/") {
                let slashes = input.match(/\//g) || [];
                if (slashes.length < 2 && cursorPos > 0 && /\d/.test(input[cursorPos - 1]) && input[cursorPos - 1] !== "/") {
                    return true;
                }
            }
            return false;
        }
        formatDate(e) {
            const target = e.target;
            if (!target) {
                return;
            }
            const id = `#${target.id}`;
            let val = $(id).val();
            if (!val) {
                return;
            }
            val = val.replace(/[^\d/]/g, "");
            let newVal = "";
            if (/^\d{8}$/.test(val)) {
                newVal = val.substring(0, 2) + "/" + val.substring(2, 4) + "/" + val.substring(4);
            }
            else if (/^\d{4}$/.test(val)) {
                newVal = val.substring(0, 2) + "/" + val.substring(2) + "/";
            }
            else if (/^\d{2}\/\d{2}$/.test(val)) {
                newVal = val + "/";
            }
            else if (/^\d\/\d{2}\/\d{4}$/.test(val)) {
                newVal = "0" + val;
            }
            else if (/^\d{2}\/\d\/\d{4}$/.test(val)) {
                newVal = val.substring(0, 3) + "0" + val.substring(3);
            }
            else if (/^\d\/\d\/\d{4}$/.test(val)) {
                newVal = "0" + val.charAt(0) + "/" + "0" + val.charAt(2) + "/" + val.substring(4);
            }
            else {
                newVal = $(id).val();
            }
            $(id).val(newVal);
            kendoWin.dataChanged();
            dateFunc.indicateDateValueIsValid(id);
        }
        onIndicateDateValueIsValid(e) {
            const target = e.target;
            if (!target) {
                return;
            }
            const idHash = `#${target.id}`;
            if ($(idHash).length > 0
                && $(idHash).hasClass("invalidValue")
                && dateFunc.isValidUsDate($(idHash).val())) {
                $(idHash).removeClass("invalidValue");
            }
        }
        indicateDateValueIsValid(id) {
            const idHash = kendoUtil.prefixHash(id);
            if ($(idHash).length > 0) {
                if (dateFunc.isValidUsDate($(idHash).val())) {
                    $(idHash).removeClass("invalidValue");
                }
                else {
                    $(idHash).addClass("invalidValue");
                }
            }
        }
        isValidUsDate(date) {
            const dateRegex = /^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/;
            return dateRegex.test(date);
        }
        showDatePrompt(title, onDateSelected, dateVale = null) {
            const dialogElement = $("<div></div>");
            const dialog = dialogElement.kendoDialog({
                width: "340px",
                height: "180px",
                title: title,
                closable: false,
                modal: true,
                content: '<div style="width: 132px; margin: 0 auto; padding-top: 20px; padding-bottom: 20px; "><input id="datePromptPicker" placeholder="MM/DD/YYYY"/></div>',
                actions: [
                    {
                        text: "OK",
                        primary: true,
                        action() {
                            const selectedDate = $("#datePromptPicker").data("kendoDatePicker").value();
                            if (selectedDate) {
                                onDateSelected(selectedDate);
                            }
                        }
                    },
                    { text: "Cancel", action() { } }
                ],
                open: function () {
                    const dialogInstance = this;
                    dialogInstance.wrapper.css({
                        bottom: "25%",
                        marginTop: "0",
                        transform: "none"
                    });
                    const datePicker = $("#datePromptPicker").kendoDatePicker({
                        value: dateVale,
                        format: "MM/dd/yyyy",
                        change() {
                            validateDate();
                        }
                    }).data("kendoDatePicker");
                    const okButton = dialogInstance.element.closest(".k-dialog").find(".k-button-primary");
                    function validateDate() {
                        const dateValue = $("#datePromptPicker").val();
                        if (dateFunc.isValidUsDate(dateValue)) {
                            okButton.removeAttr("disabled");
                        }
                        else {
                            okButton.attr("disabled", "disabled");
                        }
                    }
                    validateDate();
                    $("#datePromptPicker")
                        .on("keypress", dateFunc.isDateInput)
                        .on("focusout", dateFunc.formatDate)
                        .on("keyup", (e) => {
                        validateDate();
                        dateFunc.onIndicateDateValueIsValid(e);
                    });
                },
                close: function () {
                    const dialogInstance = this;
                    const datePicker = $("#datePromptPicker").data("kendoDatePicker");
                    if (datePicker) {
                        datePicker.destroy();
                    }
                    $("#datePromptPicker").off();
                    dialogInstance.destroy();
                    dialogElement.remove();
                }
            }).data("kendoDialog");
            dialog.open();
        }
    }
    AppFunc.DateFunc = DateFunc;
})(AppFunc || (AppFunc = {}));
var dateFunc = new AppFunc.DateFunc();
var AresFunc;
(function (AresFunc) {
    const nameBenefitDocs = "benefitDocs";
    const docSourceCarrier = "Carrier";
    const docSourceCarrierPlan = "Carrier Plan";
    class BenefitDocs {
        constructor() {
            this.areaName = nameBenefitDocs;
        }
        getController(docSource) {
            switch (docSource) {
                case docSourceCarrier:
                    return "CarrierBenefitDocs";
                case docSourceCarrierPlan:
                    return "CarrierPlanBenefitDocs";
                default:
                    return "BenefitDocs";
            }
        }
        documentDownload() {
            const dataItem = benefitDocs.getSelectedDataItem();
            if (!dataItem)
                return;
            appFunc.downloadFile(`/${benefitDocs.getController(dataItem.Doc_Source)}/FileDownload?itemId=${dataItem.Benefit_Doc_ID}&erId=${dataItem.ER_ID}`);
        }
        documentDisplay() {
            const dataItem = benefitDocs.getSelectedDataItem();
            if (!dataItem || !dataItem.Document_Is_Viewable_Ind)
                return;
            kendoWin.openItemWin("View Benefit Document", `/${benefitDocs.getController(dataItem.Doc_Source)}/FileDisplay`, { itemId: dataItem.Benefit_Doc_ID, erId: dataItem.ER_ID }, 1024, 0, false);
        }
        viewItem(e) {
            const dataItem = kendoGrid.getGridDataItem(e);
            if (!dataItem)
                return;
            if (dataItem.Document_Is_Viewable_Ind) {
                benefitDocs.documentDisplay();
            }
            else {
                benefitDocs.documentDownload();
            }
        }
        getSelectedDataItem() {
            const grid = $(`#${nameBenefitDocs}Grid`).data("kendoGrid");
            return grid ? grid.dataItem(grid.select()) : null;
        }
        gridRowChanged() {
            const toolbar = $(`#${nameBenefitDocs}GridToolbar`).data("kendoToolBar");
            if (!toolbar)
                return;
            const dataItem = benefitDocs.getSelectedDataItem();
            toolbar.enable($(`#btn${nameBenefitDocs}Download`), !!dataItem);
            toolbar.enable($(`#btn${nameBenefitDocs}Display`), !!dataItem && dataItem.Document_Is_Viewable_Ind === true);
        }
        listCargo() {
            return {
                __RequestVerificationToken: appFunc.getVerificationToken()
            };
        }
        gridDataBound() {
            const gridId = `#${nameBenefitDocs}Grid`;
            const grid = $(gridId).data("kendoGrid");
            kendoGrid.onRowDoubleClick(gridId, benefitDocs.viewItem);
            kendoGrid.selectTopRowIfNoneSelected(grid);
            benefitDocs.gridRowChanged();
        }
    }
    AresFunc.BenefitDocs = BenefitDocs;
})(AresFunc || (AresFunc = {}));
var benefitDocs = new AresFunc.BenefitDocs();
var AresFunc;
(function (AresFunc) {
    const nameBenefitDocView = "benefitDocView";
    class BenefitDocView {
        constructor() {
            this.areaName = nameBenefitDocView;
            this.firstRender = true;
        }
        init() {
            benefitDocView.firstRender = true;
            kendoWin.setItemWindowProp(`#${nameBenefitDocView}Container`, `#${nameBenefitDocView}Toolbar`, 10, benefitDocView.onWindowResized);
            benefitDocView.onWindowResized();
        }
        onWindowResized() {
            const viewer = $("#benefitDocPdfViewer");
            if (!viewer.length)
                return;
            const height = $(`#${nameBenefitDocView}Container`).height() - 60;
            viewer.attr("style", `width: 99.8%; height: ${height}px;`);
        }
        onPdfRender(e) {
            if (!benefitDocView.firstRender)
                return;
            benefitDocView.firstRender = false;
            const pdfViewer = e.sender;
            pdfViewer.zoom("auto");
            pdfViewer.resize(true);
        }
        print() {
            const frame = $("#work_iframe");
            frame.off("load").on("load", () => {
                window.frames["work_iframe"].document.title = $("#hidBenefitDocTitle").val();
                window.frames["work_iframe"].focus();
                window.frames["work_iframe"].print();
            });
            frame.attr("src", $("#hidBenefitDocFileUrl").val());
        }
    }
    AresFunc.BenefitDocView = BenefitDocView;
})(AresFunc || (AresFunc = {}));
var benefitDocView = new AresFunc.BenefitDocView();
var AresFunc;
(function (AresFunc) {
    const nameOeVebaRegisterArea = "oeVebaRegister";
    const newPasswordFields = "#NewPassword, #ConfirmPassword";
    class OeVebaRegister {
        constructor() {
            this.areaName = nameOeVebaRegisterArea;
            this.onRegisterStep = false;
            this.busy = false;
            this.redirecting = false;
            this.phoneCompletes = false;
            this.phoneReturnUrl = "";
            this.emailCancelTimer = 0;
        }
        init() {
            $(newPasswordFields).attr("autocomplete", "new-password");
            $(`#PersonalPhone`).on("input", () => this.togglePhoneConsent());
            $(`#${this.areaName}PhoneConfirmEntry`).on("keydown", "input", (e) => {
                if (e.which === 13) {
                    e.preventDefault();
                    this.confirmInlinePhone();
                }
            });
            appFunc.setFocus("#SubscriberSsn");
        }
        previewStepTwo() {
            const fakeResponse = {
                success: true,
                pin: "1234",
                pinPayload: "",
                subscriberName: "John Sample",
                isDependent: false,
                isVebaMember: true,
                emailExists: false,
                emailPending: false,
                emailExpired: false,
                emailCancelAllowed: false,
                emailCancelWaitSeconds: 0,
                personalEmailMasked: "",
                phoneExists: false,
                phonePending: false,
                phoneExpired: false,
                phoneCompletes: false,
                personalPhoneMasked: "",
                phonePayload: ""
            };
            this.showRegisterStep(fakeResponse);
            $(`#PersonalPhone`).val("555-123-4567");
            this.togglePhoneConsent();
            $(`#${this.areaName}BackBtn`).hide();
        }
        next() {
            if (this.busy) {
                return;
            }
            if (this.onRegisterStep) {
                this.submitRegistration();
            }
            else {
                this.verifyMember();
            }
        }
        back() {
            if (this.busy) {
                return;
            }
            this.onRegisterStep = false;
            this.clearEmailCancelTimer();
            this.restoreInlinePhonePanelHome();
            $(`#${this.areaName}Register`).hide();
            $(`#${this.areaName}PhoneConsentRow`).hide();
            $(`#${this.areaName}PhoneConfirmPanel`).hide();
            $(`#${this.areaName}Lookup`).show();
            $(`#${this.areaName}BackBtn`).hide();
            $(`#${this.areaName}Title`).text("Member Registration");
            $(`#${this.areaName}NextBtn`).text("Next");
            appFunc.setFocus("#SubscriberSsn");
        }
        verifyMember() {
            const form = $(`#${this.areaName}Form`);
            if (!form.valid()) {
                return;
            }
            this.setBusy(true);
            $.ajax({
                url: "/Register/Verify",
                type: "POST",
                cache: false,
                data: this.lookupData(),
                success: (response) => {
                    try {
                        if (response.success === true) {
                            this.showRegisterStep(response);
                        }
                        else {
                            this.showError(response.message);
                        }
                    }
                    catch (e) {
                        appFunc.logEventError("Register verify failed");
                        this.showError(null);
                    }
                },
                error: (jqXHR) => {
                    appFunc.logEventError("Register verify failed");
                    if (jqXHR && jqXHR.status === 429) {
                        this.showError("Too many attempts. Please wait a moment and try again.");
                    }
                },
                complete: () => {
                    this.setBusy(false);
                }
            });
        }
        submitRegistration() {
            const form = $(`#${this.areaName}Form`);
            if (!form.valid()) {
                return;
            }
            this.redirecting = false;
            this.setBusy(true);
            $.ajax({
                url: "/Register/Submit",
                type: "POST",
                cache: false,
                data: this.registerData(),
                success: (response) => {
                    try {
                        if (response.success === true) {
                            if (response.requiresEmailConfirm === true) {
                                this.showEmailConfirmNotice(response.message, response.requiresPhoneConfirm === true, response.phonePayload);
                            }
                            else if (response.requiresPhoneConfirm === true) {
                                this.showInlinePhonePanel(response.message, response.phonePayload, response.phoneCompletes === true, response.redirectUrl);
                            }
                            else if (response.requiresCompletion === true) {
                                this.showCompletionNotice(response.message, response.returnUrl || response.redirectUrl);
                            }
                            else {
                                this.redirecting = this.redirect(response.redirectUrl);
                                if (!this.redirecting) {
                                    this.showError("Registration completed but no redirect was provided.");
                                }
                            }
                        }
                        else {
                            this.showError(response.message);
                        }
                    }
                    catch (e) {
                        appFunc.logEventError("Register submit failed");
                        this.showError(null);
                    }
                },
                error: () => {
                    appFunc.logEventError("Register submit failed");
                },
                complete: () => {
                    if (!this.redirecting) {
                        this.setBusy(false);
                    }
                }
            });
        }
        showRegisterStep(response) {
            this.onRegisterStep = true;
            this.restoreInlinePhonePanelHome();
            this.clearEmailCancelTimer();
            $(`#${this.areaName}PhoneConfirmPanel`).hide();
            $(`#${this.areaName}PhoneExpiredRow`).hide();
            $(`#${this.areaName}EmailExpiredRow`).hide();
            $(`#${this.areaName}EmailCancelRow`).hide();
            $(`#${this.areaName}PasswordSection`).show();
            $(`#${this.areaName}NextBtn`).show();
            $(newPasswordFields).val("");
            $(`#EmpPin`).val(response.pin);
            $(`#PinPayload`).val(response.pinPayload);
            $(`#SubscriberName`).val(response.subscriberName);
            $(`#IsVebaMember`).val(response.isVebaMember === true ? "true" : "false");
            $(`#EmailExists`).val(response.emailExists === true ? "true" : "false");
            $(`#PhoneExists`).val(response.phoneExists === true ? "true" : "false");
            $(`#${this.areaName}MemberTypeLabel`).text(response.isDependent === true ? "Dependent" : "Subscriber");
            $(`#${this.areaName}SubscriberName`).text(response.subscriberName);
            $(`#${this.areaName}PinDisplay`).text(response.pin);
            if (response.emailExists === true) {
                this.setExistingContactValue(`#${this.areaName}EmailExistingValue`, response.personalEmailMasked || "", response.emailPending === true, "Confirmation pending \u2014 check your email to finish.");
                $(`#${this.areaName}EmailExistingRow`).show();
                $(`#${this.areaName}PersonalEmailRow`).hide();
                $(`#${this.areaName}ConfirmPersonalEmailRow`).hide();
                $(`#PersonalEmail`).val("").prop("disabled", true);
                $(`#ConfirmPersonalEmail`).val("").prop("disabled", true);
            }
            else {
                if (response.emailExpired === true) {
                    const maskedEmail = response.personalEmailMasked || "";
                    const emailPart = maskedEmail ? ` ${maskedEmail}` : "";
                    $(`#${this.areaName}EmailExpiredNote`).text(`Confirmation link expired \u2014 the email${emailPart} was not confirmed, you can try again.`);
                    $(`#${this.areaName}EmailExpiredRow`).show();
                }
                $(`#${this.areaName}EmailExistingRow`).hide();
                $(`#${this.areaName}PersonalEmailRow`).show();
                $(`#${this.areaName}ConfirmPersonalEmailRow`).show();
                $(`#PersonalEmail`).prop("disabled", false);
                $(`#ConfirmPersonalEmail`).prop("disabled", false);
            }
            if (response.phoneExists === true) {
                $(`#${this.areaName}PersonalPhoneRow`).hide();
                $(`#PersonalPhone`).val("").prop("disabled", true);
                if (response.phonePending === true) {
                    $(`#${this.areaName}PhoneExistingRow`).hide();
                    $(`#${this.areaName}PasswordSection`).hide();
                    $(`#${this.areaName}NextBtn`).hide();
                    this.setInlinePhonePrompt(response.personalPhoneMasked || "");
                    this.moveInlinePhonePanelToSlot();
                    this.revealInlinePhonePanel(response.phonePayload || "", response.phoneCompletes === true, "");
                }
                else {
                    this.setExistingContactValue(`#${this.areaName}PhoneExistingValue`, response.personalPhoneMasked || "", false, "");
                    $(`#${this.areaName}PhoneExistingRow`).show();
                }
            }
            else if (response.phoneExpired === true) {
                const maskedPhone = response.personalPhoneMasked || "";
                const phonePart = maskedPhone ? ` ${maskedPhone}` : "";
                $(`#${this.areaName}PhoneExpiredNote`).text(`Verification code expired \u2014 the phone${phonePart} was not confirmed, you can try again.`);
                $(`#${this.areaName}PhoneExpiredRow`).show();
                $(`#${this.areaName}PhoneExistingRow`).hide();
                $(`#${this.areaName}PersonalPhoneRow`).show();
                $(`#PersonalPhone`).val("").prop("disabled", false);
            }
            else {
                $(`#${this.areaName}PhoneExistingRow`).hide();
                $(`#${this.areaName}PersonalPhoneRow`).show();
                $(`#PersonalPhone`).prop("disabled", false);
            }
            this.togglePhoneConsent();
            $(`#${this.areaName}Lookup`).hide();
            $(`#${this.areaName}Register`).show();
            $(`#${this.areaName}BackBtn`).show();
            const phonePending = response.phoneExists === true && response.phonePending === true;
            const passwordOnly = response.emailExists === true && response.phoneExists === true;
            if (response.emailPending === true && !phonePending) {
                this.scheduleEmailCancelReveal(response.emailCancelAllowed === true, response.emailCancelWaitSeconds || 0);
            }
            if (phonePending) {
                $(`#${this.areaName}Title`).text("Verify Your Phone");
            }
            else {
                $(`#${this.areaName}Title`).text(passwordOnly ? "Update Your Password" : "Member Registration");
            }
            $(`#${this.areaName}NextBtn`).html(passwordOnly ? "Update Password" : "Register <i class='fal fa-arrow-right'></i>");
            if (phonePending) {
                appFunc.setFocus("#InlinePhoneCode");
            }
            else {
                appFunc.setFocus(response.emailExists === true ? "#NewPassword" : "#PersonalEmail");
            }
        }
        setExistingContactValue(selector, masked, pending, pendingNote) {
            const target = $(selector);
            target.empty().text(masked);
            if (pending) {
                target.append($("<span>").addClass("veba-pending-note").text(pendingNote));
            }
        }
        scheduleEmailCancelReveal(allowed, waitSeconds) {
            if (allowed) {
                $(`#${this.areaName}EmailCancelRow`).show();
                return;
            }
            if (waitSeconds <= 0) {
                return;
            }
            this.emailCancelTimer = window.setTimeout(() => {
                this.emailCancelTimer = 0;
                $(`#${this.areaName}EmailCancelRow`).show();
            }, waitSeconds * 1000);
        }
        clearEmailCancelTimer() {
            if (this.emailCancelTimer) {
                window.clearTimeout(this.emailCancelTimer);
                this.emailCancelTimer = 0;
            }
        }
        cancelPendingEmail() {
            if (this.busy) {
                return;
            }
            this.setBusy(true);
            $.ajax({
                url: "/Register/CancelEmail",
                type: "POST",
                cache: false,
                data: this.registerData(),
                success: (response) => {
                    if (response.success === true) {
                        this.showEmailEntryAfterCancel();
                    }
                    else {
                        this.showError(response.message);
                    }
                },
                error: () => {
                    appFunc.logEventError("Register cancel email failed");
                    this.showError(null);
                },
                complete: () => {
                    this.setBusy(false);
                }
            });
        }
        showEmailEntryAfterCancel() {
            this.clearEmailCancelTimer();
            $(`#${this.areaName}EmailCancelRow`).hide();
            $(`#${this.areaName}EmailExistingRow`).hide();
            $(`#EmailExists`).val("false");
            $(`#${this.areaName}EmailExpiredNote`).text("The pending email was canceled \u2014 enter your email below to try again.");
            $(`#${this.areaName}EmailExpiredRow`).show();
            $(`#PersonalEmail`).val("").prop("disabled", false);
            $(`#ConfirmPersonalEmail`).val("").prop("disabled", false);
            $(`#${this.areaName}PersonalEmailRow`).show();
            $(`#${this.areaName}ConfirmPersonalEmailRow`).show();
            $(`#${this.areaName}Title`).text("Member Registration");
            $(`#${this.areaName}NextBtn`).html("Register <i class='fal fa-arrow-right'></i>");
            appFunc.setFocus("#PersonalEmail");
        }
        togglePhoneConsent() {
            const hasPhone = ($(`#PersonalPhone`).val() || "").trim().length > 0;
            $(`#${this.areaName}PhoneConsentRow`).toggle(hasPhone);
        }
        confirmInlinePhone() {
            if (this.busy) {
                return;
            }
            const widget = $(`#InlinePhoneCode`).data("kendoOTPInput");
            const code = widget ? (widget.value() || "") : "";
            if (!/^\d{6}$/.test(code)) {
                this.showError("Please enter the 6-digit verification code.");
                return;
            }
            this.setBusy(true);
            $.ajax({
                url: "/Register/VerifyPhoneCode",
                type: "POST",
                cache: false,
                data: {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    Payload: $(`#${this.areaName}PhonePayload`).val(),
                    Code: code,
                    Completes: this.phoneCompletes
                },
                success: (response) => {
                    if (response.success === true) {
                        $(`#${this.areaName}PhoneConfirmEntry`).hide();
                        $(`#${this.areaName}PhoneConfirmDoneMessage`).text(response.message);
                        const continueUrl = this.phoneCompletes ? (response.redirectUrl || this.phoneReturnUrl) : "";
                        if (continueUrl) {
                            $(`#${this.areaName}PhoneConfirmContinueBtn`).attr("href", continueUrl);
                            $(`#${this.areaName}PhoneConfirmContinue`).show();
                        }
                        $(`#${this.areaName}PhoneConfirmDone`).show();
                    }
                    else {
                        this.showError(response.message);
                    }
                },
                error: () => {
                    appFunc.logEventError("Register inline phone verify failed");
                    this.showError(null);
                },
                complete: () => {
                    this.setBusy(false);
                }
            });
        }
        showEmailConfirmNotice(message, showPhoneConfirm = false, phonePayload = "") {
            this.hideRegisterForm();
            $(`#${this.areaName}EmailConfirmMessage`).text(message);
            $(`#${this.areaName}EmailConfirmNotice`).show();
            if (showPhoneConfirm) {
                this.revealInlinePhonePanel(phonePayload, false, "");
            }
        }
        showInlinePhonePanel(message, phonePayload, completes, returnUrl) {
            this.hideRegisterForm();
            this.revealInlinePhonePanel(phonePayload, completes, returnUrl);
        }
        showCompletionNotice(message, returnUrl) {
            this.hideRegisterForm();
            $(`#${this.areaName}CompletionMessage`).text(message);
            if (returnUrl) {
                $(`#${this.areaName}CompletionContinueBtn`).attr("href", returnUrl);
            }
            $(`#${this.areaName}CompletionNotice`).show();
        }
        hideRegisterForm() {
            this.clearEmailCancelTimer();
            $(`#${this.areaName}Form`).hide();
            $(`#${this.areaName}BackBtn`).hide();
            $(`#${this.areaName}NextBtn`).hide();
            this.restoreInlinePhonePanelHome();
            $(`#${this.areaName}PhoneConfirmPanel`).hide();
        }
        revealInlinePhonePanel(phonePayload, completes, returnUrl) {
            this.phoneCompletes = completes;
            this.phoneReturnUrl = returnUrl || "";
            $(`#${this.areaName}PhonePayload`).val(phonePayload || "");
            $(`#${this.areaName}PhoneConfirmContinue`).hide();
            $(`#${this.areaName}PhoneConfirmDone`).hide();
            $(`#${this.areaName}PhoneConfirmEntry`).show();
            $(`#${this.areaName}PhoneConfirmPanel`).show();
        }
        setInlinePhonePrompt(maskedPhone) {
            const phonePart = maskedPhone ? ` ${maskedPhone}` : "";
            $(`#${this.areaName}PhoneConfirmPrompt`).html(`Enter the code sent to your phone${phonePart}. This code expires in 60 minutes.`);
        }
        moveInlinePhonePanelToSlot() {
            $(`#${this.areaName}PhoneConfirmPanel`).appendTo(`#${this.areaName}PhonePanelSlot`);
        }
        restoreInlinePhonePanelHome() {
            const panel = $(`#${this.areaName}PhoneConfirmPanel`);
            if (!panel.parent().is(`#${this.areaName}PhonePanelSlot`)) {
                return;
            }
            panel.insertBefore(`#${this.areaName}CompletionNotice`);
        }
        showError(message) {
            kendoWin.openInfoWin("Alert", message || "An unexpected error occurred!");
        }
        redirect(url) {
            if (!url) {
                return false;
            }
            window.location.href = url;
            return true;
        }
        setBusy(isBusy) {
            this.busy = isBusy;
            $(`#${this.areaName}NextBtn`).prop("disabled", isBusy);
            $(`#${this.areaName}BackBtn`).prop("disabled", isBusy);
            kendo.ui.progress($(`#${this.areaName}Container`), isBusy);
        }
        lookupData() {
            return {
                __RequestVerificationToken: appFunc.getVerificationToken(),
                SubscriberSsn: $(`#SubscriberSsn`).val(),
                Birthdate: $(`#Birthdate`).val(),
                ZipCode: $(`#ZipCode`).val()
            };
        }
        registerData() {
            return {
                __RequestVerificationToken: appFunc.getVerificationToken(),
                SubscriberSsn: $(`#SubscriberSsn`).val(),
                Birthdate: $(`#Birthdate`).val(),
                ZipCode: $(`#ZipCode`).val(),
                EmpPin: $(`#EmpPin`).val(),
                PinPayload: $(`#PinPayload`).val(),
                SubscriberName: $(`#SubscriberName`).val(),
                IsVebaMember: $(`#IsVebaMember`).val(),
                EmailExists: $(`#EmailExists`).val(),
                PhoneExists: $(`#PhoneExists`).val(),
                PersonalEmail: $(`#PersonalEmail`).val(),
                ConfirmPersonalEmail: $(`#ConfirmPersonalEmail`).val(),
                PersonalPhone: $(`#PersonalPhone`).val(),
                NewPassword: $(`#NewPassword`).val(),
                ConfirmPassword: $(`#ConfirmPassword`).val()
            };
        }
    }
    AresFunc.OeVebaRegister = OeVebaRegister;
})(AresFunc || (AresFunc = {}));
var oeVebaRegister = new AresFunc.OeVebaRegister();
var AresFunc;
(function (AresFunc) {
    const nameOeVebaResetPasswordArea = "oeVebaResetPassword";
    class OeVebaResetPassword {
        constructor() {
            this.areaName = nameOeVebaResetPasswordArea;
            this.onPasswordStep = false;
            this.busy = false;
        }
        init() {
            appFunc.setFocus("#SubscriberSsn");
        }
        next() {
            if (this.busy) {
                return;
            }
            if (this.onPasswordStep) {
                this.submitPassword();
            }
            else {
                this.verifyMember();
            }
        }
        back() {
            if (this.busy) {
                return;
            }
            this.onPasswordStep = false;
            $(`#${this.areaName}PasswordStep`).hide();
            $(`#${this.areaName}Lookup`).show();
            $(`#${this.areaName}BackBtn`).hide();
            $(`#${this.areaName}Title`).text("Change Password");
            $(`#${this.areaName}NextBtn`).text("Next");
            appFunc.setFocus("#SubscriberSsn");
        }
        verifyMember() {
            const form = $(`#${this.areaName}Form`);
            if (!form.valid()) {
                return;
            }
            this.setBusy(true);
            $.ajax({
                url: "/ResetPassword/Verify",
                type: "POST",
                cache: false,
                data: this.lookupData(),
                success: (response) => {
                    try {
                        if (response.success === true) {
                            this.showPasswordStep(response);
                        }
                        else {
                            this.showError(response.message);
                        }
                    }
                    catch (e) {
                        appFunc.logEventError("ResetPassword verify failed");
                        this.showError(null);
                    }
                },
                error: (jqXHR) => {
                    appFunc.logEventError("ResetPassword verify failed");
                    if (jqXHR && jqXHR.status === 429) {
                        this.showError("Too many attempts. Please wait a moment and try again.");
                    }
                },
                complete: () => {
                    this.setBusy(false);
                }
            });
        }
        submitPassword() {
            const form = $(`#${this.areaName}Form`);
            if (!form.valid()) {
                return;
            }
            this.setBusy(true);
            $.ajax({
                url: "/ResetPassword/Submit",
                type: "POST",
                cache: false,
                data: this.passwordData(),
                success: (response) => {
                    try {
                        if (response.success === true) {
                            this.showCompletionNotice(response.message, response.returnUrl);
                        }
                        else {
                            this.showError(response.message);
                        }
                    }
                    catch (e) {
                        appFunc.logEventError("ResetPassword submit failed");
                        this.showError(null);
                    }
                },
                error: () => {
                    appFunc.logEventError("ResetPassword submit failed");
                },
                complete: () => {
                    this.setBusy(false);
                }
            });
        }
        showPasswordStep(response) {
            this.onPasswordStep = true;
            $(`#EmpPin`).val(response.pin);
            $(`#PinPayload`).val(response.pinPayload);
            $(`#SubscriberName`).val(response.subscriberName);
            $(`#${this.areaName}SubscriberName`).text(response.subscriberName);
            $(`#${this.areaName}PinDisplay`).text(response.pin);
            $(`#${this.areaName}Lookup`).hide();
            $(`#${this.areaName}PasswordStep`).show();
            $(`#${this.areaName}BackBtn`).show();
            $(`#${this.areaName}Title`).text("Change Password");
            $(`#${this.areaName}NextBtn`).text("Update Password");
            appFunc.setFocus("#NewPassword");
        }
        showCompletionNotice(message, returnUrl) {
            $(`#${this.areaName}Form`).hide();
            $(`#${this.areaName}BackBtn`).hide();
            $(`#${this.areaName}NextBtn`).hide();
            $(`#${this.areaName}CompletionMessage`).text(message);
            if (returnUrl) {
                $(`#${this.areaName}CompletionContinueBtn`).attr("href", returnUrl);
            }
            $(`#${this.areaName}CompletionNotice`).show();
        }
        showError(message) {
            kendoWin.openInfoWin("Alert", message || "An unexpected error occurred!");
        }
        setBusy(isBusy) {
            this.busy = isBusy;
            $(`#${this.areaName}NextBtn`).prop("disabled", isBusy);
            $(`#${this.areaName}BackBtn`).prop("disabled", isBusy);
            kendo.ui.progress($(`#${this.areaName}Container`), isBusy);
        }
        lookupData() {
            return {
                __RequestVerificationToken: appFunc.getVerificationToken(),
                SubscriberSsn: $(`#SubscriberSsn`).val(),
                Birthdate: $(`#Birthdate`).val(),
                ZipCode: $(`#ZipCode`).val()
            };
        }
        passwordData() {
            return {
                __RequestVerificationToken: appFunc.getVerificationToken(),
                SubscriberSsn: $(`#SubscriberSsn`).val(),
                Birthdate: $(`#Birthdate`).val(),
                ZipCode: $(`#ZipCode`).val(),
                EmpPin: $(`#EmpPin`).val(),
                PinPayload: $(`#PinPayload`).val(),
                SubscriberName: $(`#SubscriberName`).val(),
                NewPassword: $(`#NewPassword`).val(),
                ConfirmPassword: $(`#ConfirmPassword`).val()
            };
        }
    }
    AresFunc.OeVebaResetPassword = OeVebaResetPassword;
})(AresFunc || (AresFunc = {}));
var oeVebaResetPassword = new AresFunc.OeVebaResetPassword();
var AppFunc;
(function (AppFunc) {
    class AddressFunc {
        performZipCodeLookup(modelName, zipCode, successCallback) {
            if (modelName && zipCode && zipCode.length == 5) {
                $.ajax({
                    url: "/App/Lookup/GetAddressByZipCode",
                    type: "POST",
                    cache: false,
                    data: {
                        __RequestVerificationToken: appFunc.getVerificationToken(),
                        zipCode: zipCode
                    },
                    success: successCallback,
                    error(result) {
                        appFunc.logJavaScriptError(result.responseText);
                    }
                });
            }
        }
        populateCityStateByZipCode(modelName, zipCode) {
            const noAutoZip = $(`#${modelName}_No_Auto_Zip_Ind`).is(':checked');
            this.performZipCodeLookup(modelName, zipCode, (result) => {
                if (result) {
                    $(`#${modelName}_Zip_Code`).removeClass("invalidValue");
                    $(`#${modelName}_Zip_Code_Found_Ind`).val("true");
                    if (noAutoZip == false) {
                        addressFunc.setCityState(modelName, result.L_Zip_Code_City, result.L_Zip_Code_State);
                    }
                }
                else {
                    $(`#${modelName}_Zip_Code`).addClass("invalidValue");
                    $(`#${modelName}_Zip_Code_Found_Ind`).val("false");
                    if (noAutoZip == false) {
                        addressFunc.zipCodeNotFound(modelName);
                    }
                }
            });
        }
        checkIfZipCodeIdValid(modelName) {
            const currentZip = $(`#${modelName}_ZipCode`).val().trim();
            this.performZipCodeLookup(modelName, currentZip, (result) => {
                if (result) {
                    $(`#${modelName}_Zip_Code`).removeClass("invalidValue");
                    $(`#${modelName}_Zip_Code_Found_Ind`).val("true");
                }
                else {
                    $(`#${modelName}_Zip_Code`).addClass("invalidValue");
                    $(`#${modelName}_Zip_Code_Found_Ind`).val("false");
                }
            });
        }
        setCityState(modelName, city, state) {
            const currentCity = $(`#${modelName}_City`).val().trim();
            const currentState = $(`#${modelName}_State`).val().trim();
            let changedMessage = "";
            if (currentCity !== city) {
                $(`#${modelName}_City`).val(city);
                $(`#${modelName}_City`).trigger("change");
                changedMessage += "City set to: " + city + "<br>";
            }
            if (currentState !== state) {
                $(`#${modelName}_State`).val(state);
                $(`#${modelName}_State`).trigger("change");
                changedMessage += "State set to: " + state;
            }
            if (changedMessage != "")
                appFunc.mainWindowNotify(changedMessage, NotifyType.Info);
            addressFunc.disableCityStateInput(modelName);
        }
        zipCodeNotFound(modelName) {
            const currentCity = $(`#${modelName}_City`).val();
            const currentState = $(`#${modelName}_State`).val();
            if (currentCity !== "") {
                $(`#${modelName}_City`).val("");
            }
            if (currentState !== "") {
                $(`#${modelName}_State`).val("");
            }
        }
        onAutoZipChanged(modelName, autoZipChecked) {
            if (autoZipChecked) {
                addressFunc.enableCityStateInput(modelName);
            }
            else {
                const currentCity = $(`#${modelName}_City`).val().trim();
                const currentState = $(`#${modelName}_State`).val().trim();
                if (currentCity != "" || currentState != "") {
                    kendoWin.openYesNoWin("Alert", "Switching to zip code city/state lookup will overwrite any manually entered values if they differ<br><br>Continue?", "addressFunc.disableCityStateInputDo", modelName, null, null, true);
                }
                else {
                    addressFunc.disableCityStateInput(modelName);
                }
            }
        }
        disableCityStateInputDo(yesNoVal, modelName) {
            if (yesNoVal === 0) {
                $(`#${modelName}_No_Auto_Zip_Ind`).prop('checked', true);
                return;
            }
            ;
            addressFunc.disableCityStateInput(modelName);
            addressFunc.populateCityStateByZipCode(modelName, $(`#${modelName}_Zip_Code`).val());
        }
        enableCityStateInput(modelName) {
            $(`#${modelName}_City`).prop("readonly", false).removeClass("k-readonly").removeAttr("tabindex");
            $(`#${modelName}_State`).prop("readonly", false).removeClass("k-readonly").removeAttr("tabindex");
        }
        disableCityStateInput(modelName) {
            $(`#${modelName}_City`).prop("readonly", true).addClass("k-readonly").attr("tabindex", "-1");
            $(`#${modelName}_State`).prop("readonly", true).addClass("k-readonly").attr("tabindex", "-1");
        }
    }
    AppFunc.AddressFunc = AddressFunc;
})(AppFunc || (AppFunc = {}));
var addressFunc = new AppFunc.AddressFunc();
var AppFunc;
(function (AppFunc) {
    class PersonFunc {
        firstLetterToUpperCase(name) {
            if (name == null || name.length === 0) {
                return name;
            }
            if (name.length <= 2) {
                return name;
            }
            if (name === name.toUpperCase()) {
                return name.charAt(0).toUpperCase() + name.substring(1).toLowerCase();
            }
            return name.charAt(0).toUpperCase() + name.substring(1);
        }
        autoCorrectName(name) {
            const capitalize = (word) => {
                word = word.toLowerCase();
                return word.charAt(0).toUpperCase() + word.substring(1);
            };
            const words = name.split(" ");
            const titleCasedWords = words.map((word) => {
                if (word.indexOf('-') !== -1) {
                    return word.split('-').map(capitalize).join('-');
                }
                else if (word.indexOf("'") !== -1) {
                    return word.split("'").map(capitalize).join("'");
                }
                else {
                    return capitalize(word);
                }
            });
            return titleCasedWords.join(" ");
        }
        autoCorrectLastName(name) {
            const capitalize = (word) => {
                word = word.toLowerCase();
                if (word.substring(0, 2) === "mc" && word.length > 2) {
                    return "Mc" + word.charAt(2).toUpperCase() + word.substring(3);
                }
                return word.charAt(0).toUpperCase() + word.substring(1);
            };
            const words = name.split(" ");
            const titleCasedWords = words.map((word) => {
                if (word.indexOf('-') !== -1) {
                    return word.split('-').map(capitalize).join('-');
                }
                else if (word.indexOf("'") !== -1) {
                    return word.split("'").map(capitalize).join("'");
                }
                else {
                    return capitalize(word);
                }
            });
            return titleCasedWords.join(" ");
        }
        onFirstNameAutoCapChange(e, idPrefix = "") {
            const widget = (e && e.sender) ? e.sender : null;
            const isChecked = (e && typeof e.checked !== "undefined")
                ? !!e.checked
                : (widget && widget.options ? !!widget.options.selected : false);
            const $btnFirst = widget && widget.element ? $(widget.element) : $("#" + idPrefix + "btnAutoFormatFirstNameInd");
            if (widget && widget.options) {
                widget.options.selected = isChecked;
            }
            $("#" + idPrefix + "idAutoFormatFirstNameInd").val(isChecked ? "True" : "False");
            personFunc.firstNameChanged(idPrefix);
            const firstLabel = isChecked ? "Auto-Cap On" : "Auto-Cap off";
            $btnFirst.find(".k-button-text").text(firstLabel);
            kendoWin.dataChanged();
        }
        onLastNameAutoCapChange(e, idPrefix = "") {
            const widget = (e && e.sender) ? e.sender : null;
            const isChecked = (e && typeof e.checked !== "undefined")
                ? !!e.checked
                : (widget && widget.options ? !!widget.options.selected : false);
            const $btnLast = widget && widget.element ? $(widget.element) : $("#" + idPrefix + "btnAutoFormatLastNameInd");
            if (widget && widget.options) {
                widget.options.selected = isChecked;
            }
            $("#" + idPrefix + "idAutoFormatLastNameInd").val(isChecked ? "True" : "False");
            personFunc.lastNameChanged(idPrefix);
            const lastLabel = isChecked ? "Auto-Cap On" : "Auto-Cap off";
            $btnLast.find(".k-button-text").text(lastLabel);
            kendoWin.dataChanged();
        }
        stringIsNullOrWhiteSpace(str) {
            return str == null || str.trim().length <= 0;
        }
        isNameInput(event) {
            var char = String.fromCharCode(event.which);
            let pattern = /^[A-Za-z .'-]*$/;
            return String(char).search(pattern) != -1;
        }
        firstNameChanged(idPrefix = "") {
            const currentText = $("#" + idPrefix + "idPersonFirstName").val();
            let newText = currentText.trim().replace(/\s+/g, ' ');
            const autoInd = $("#" + idPrefix + "idAutoFormatFirstNameInd").val() == "True";
            if (autoInd) {
                newText = personFunc.autoCorrectName(newText);
            }
            else {
                newText = personFunc.firstLetterToUpperCase(newText);
            }
            if (currentText !== newText) {
                $("#" + idPrefix + "idPersonFirstName").val(newText);
            }
        }
        lastNameChanged(idPrefix = "") {
            const currentText = $("#" + idPrefix + "idPersonLastName").val();
            let newText = currentText.trim().replace(/\s+/g, ' ');
            const autoInd = $("#" + idPrefix + "idAutoFormatLastNameInd").val() == "True";
            if (autoInd) {
                newText = personFunc.autoCorrectLastName(newText);
            }
            else {
                newText = personFunc.firstLetterToUpperCase(newText);
            }
            if (currentText !== newText) {
                $("#" + idPrefix + "idPersonLastName").val(newText);
            }
        }
        middleInitialChanged(idPrefix = "") {
            const upperMi = $("#" + idPrefix + "idPersonMiddleInitial").val().toUpperCase();
            $("#" + idPrefix + "idPersonMiddleInitial").val(upperMi);
        }
        isSsnInput(event) {
            const target = event.target;
            var char = String.fromCharCode(event.which);
            let input = target.value;
            if (event.keyCode === 8 || event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 36 || event.keyCode === 35) {
                return true;
            }
            let cursorPos = event.target.selectionStart;
            let selectionEnd = event.target.selectionEnd;
            if (cursorPos !== selectionEnd) {
                input = input.substring(0, cursorPos) + input.substring(selectionEnd);
            }
            let parts = input.split('-');
            let digitCount = input.replace(/\D/g, "").length;
            if (/\d/.test(char)) {
                if (digitCount < 9) {
                    if (parts.length === 1) {
                        if (parts[0].length < 3) {
                            return true;
                        }
                        else if (parts[0].length === 3 && char !== '-') {
                            event.target.value += '-';
                            return true;
                        }
                    }
                    else if (parts.length === 2) {
                        let firstPart = parts[0];
                        let secondPart = parts[1];
                        if (cursorPos <= firstPart.length) {
                            if (firstPart.length < 3) {
                                return true;
                            }
                        }
                        else if (cursorPos > firstPart.length) {
                            if (secondPart.length < 2) {
                                return true;
                            }
                            else if (secondPart.length === 2 && char !== '-') {
                                event.target.value += '-';
                                return true;
                            }
                        }
                    }
                    else if (parts.length === 3) {
                        let firstPart = parts[0];
                        let secondPart = parts[1];
                        let thirdPart = parts[2];
                        if (cursorPos <= firstPart.length + secondPart.length + 1) {
                            if (secondPart.length < 2) {
                                return true;
                            }
                        }
                        else if (cursorPos > firstPart.length + secondPart.length + 1) {
                            if (thirdPart.length < 4) {
                                return true;
                            }
                        }
                    }
                }
            }
            if (char === "-") {
                let dashes = input.match(/-/g) || [];
                if (dashes.length < 2 && cursorPos > 0 && /\d/.test(input[cursorPos - 1]) && input[cursorPos - 1] !== '-') {
                    return true;
                }
            }
            return false;
        }
        formatSsn() {
            var val = $(this).val().replace(/\D/g, '');
            var newVal = '';
            if (val.length > 4) {
                $(this).val(val);
            }
            if ((val.length > 3) && (val.length < 6)) {
                newVal += val.substr(0, 3) + '-';
                val = val.substr(3);
            }
            if (val.length > 5) {
                newVal += val.substr(0, 3) + '-';
                newVal += val.substr(3, 2) + '-';
                val = val.substr(5);
            }
            newVal += val;
            $(this).val(newVal);
        }
        formatSsnValue(el) {
            let val = $(el).val();
            val = val.replace(/\D/g, '');
            let newVal = '';
            if (val.length > 4) {
                $(el).val(val);
            }
            if ((val.length > 3) && (val.length < 6)) {
                newVal += val.substr(0, 3) + '-';
                val = val.substr(3);
            }
            if (val.length > 5) {
                newVal += val.substr(0, 3) + '-';
                newVal += val.substr(3, 2) + '-';
                val = val.substr(5);
            }
            newVal += val;
            $(el).val(newVal);
        }
        getAge(fromdate, todate) {
            if (todate)
                todate = new Date(todate);
            else
                todate = new Date();
            fromdate = new Date(fromdate);
            var age = [], y = [todate.getFullYear(), fromdate.getFullYear()], ydiff = y[0] - y[1], m = [todate.getMonth(), fromdate.getMonth()], mdiff = m[0] - m[1], d = [todate.getDate(), fromdate.getDate()], ddiff = d[0] - d[1];
            if (mdiff < 0 || (mdiff === 0 && ddiff < 0))
                --ydiff;
            if (mdiff < 0)
                mdiff += 12;
            if (ddiff < 0) {
                fromdate.setMonth(m[1] + 1, 0);
                ddiff = fromdate.getDate() - d[1] + d[0];
                --mdiff;
            }
            if (ydiff > 0)
                age.push(ydiff + ' year' + (ydiff > 1 ? 's ' : ' '));
            if (mdiff > 0)
                age.push(mdiff + ' month' + (mdiff > 1 ? 's' : ''));
            if (ddiff > 0)
                age.push(ddiff + ' day' + (ddiff > 1 ? 's' : ''));
            if (age.length > 1)
                age.splice(age.length - 1, 0, ' and ');
            if (age.length == 0)
                return "0";
            return age.join('').toString().replace(/\s{2,}/g, ' ');
        }
    }
    AppFunc.PersonFunc = PersonFunc;
})(AppFunc || (AppFunc = {}));
var personFunc = new AppFunc.PersonFunc();
var AresFunc;
(function (AresFunc) {
    const nameEmpPersonalContactEditArea = "empPersonalContactEdit";
    class EmpPersonalContactEdit {
        constructor() {
            this.areaName = nameEmpPersonalContactEditArea;
        }
        cancelEdit() {
            kendoWin.exitItemWindow();
        }
        askConfirm() {
            const methodId = parseInt($("#empPersonalContactEditMethodId").val() || "0");
            const methodLabel = $("#empPersonalContactEditMethodLabel").val() || "Contact";
            const expirationDuration = $("#personalContactEditExpirationMessage").val() || "60 minutes";
            const isEmail = methodId === 1000;
            const newValue = isEmail ? empPersonalContactEdit.getEmailValue() : empPersonalContactEdit.getPhoneValue();
            if (newValue === null) {
                return;
            }
            const channelText = isEmail ? "email" : "SMS text message";
            const message = `You are about to update your personal ${methodLabel.toLowerCase()} to:<br/><br/>` +
                `<strong>${newValue}</strong><br/><br/>` +
                `A verification ${channelText} will be sent to that ${methodLabel.toLowerCase()} ` +
                `with a code. The code expires in ${expirationDuration}.<br/><br/>` +
                `The change is not applied until you confirm using the code.<br/><br/>` +
                `Are you sure you want to continue?`;
            const cargo = {
                methodId: methodId,
                contactValue: newValue
            };
            kendoWin.openYesNoWin(`Confirm ${channelText} Verification`, message, "empPersonalContactEdit.submitVerification", cargo, 600, 380);
        }
        getEmailValue() {
            const value = ($("#NewPersonalEmail").val() || "").trim();
            if (!value) {
                kendoWin.openInfoWin("Required", "Please enter an email.");
                return null;
            }
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(value)) {
                kendoWin.openInfoWin("Invalid Email", "Please enter a valid email address.");
                return null;
            }
            const current = ($("#ProxyEmail").val() || "").trim();
            if (current && current.toLowerCase() === value.toLowerCase()) {
                kendoWin.openInfoWin("No Change", "The new email matches your current email. Enter a different value.");
                return null;
            }
            return value;
        }
        getPhoneValue() {
            const value = ($("#NewPersonalPhone").val() || "").trim();
            if (!value) {
                kendoWin.openInfoWin("Required", "Please enter a phone.");
                return null;
            }
            const newDigits = (value.match(/\d/g) || []).join("");
            if (newDigits.length < 10) {
                kendoWin.openInfoWin("Invalid Phone", "Please enter a valid phone number with at least 10 digits.");
                return null;
            }
            const current = ($("#ProxyEmail").val() || "").trim();
            const currentDigits = (current.match(/\d/g) || []).join("");
            if (currentDigits && currentDigits === newDigits) {
                kendoWin.openInfoWin("No Change", "The new phone matches your current phone. Enter a different value.");
                return null;
            }
            return value;
        }
        submitVerification(yesNoVal, objectParam) {
            if (yesNoVal !== 1) {
                return;
            }
            const expirationDuration = $("#personalContactEditExpirationMessage").val() || "60 minutes";
            const isEmail = objectParam.methodId === 1000;
            const url = isEmail
                ? "/PersonalContact/CreatePersonalEmailRequest"
                : "/PersonalContact/CreatePersonalPhoneRequest";
            const data = isEmail
                ? {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    NewPersonalEmail: objectParam.contactValue
                }
                : {
                    __RequestVerificationToken: appFunc.getVerificationToken(),
                    NewPersonalPhone: objectParam.contactValue
                };
            $.ajax({
                url: url,
                type: "POST",
                cache: false,
                data: data,
                success(result) {
                    if (result && result.success) {
                        kendoWin.exitItemWindow();
                        const channel = objectParam.methodId === 1000 ? "email" : "SMS";
                        const target = objectParam.methodId === 1000 ? "email address" : "phone number";
                        empPersonalContact.openManagePersonalContact();
                        kendoWin.openInfoWin("Verification Sent", `Verification ${channel} sent to <strong>${result.maskedContact || objectParam.contactValue}</strong>.<br/><br/>` +
                            `It will expire in ${expirationDuration} - ${result.expiresDisplay ? result.expiresDisplay : ""}.<br/><br/>` +
                            `Open the message and use the code to verify your ${target}.`);
                    }
                    else {
                        kendoWin.openInfoWin("Verification Failed", (result && result.message) || "Unable to send verification.");
                    }
                },
                error() {
                    kendoWin.openInfoWin("Error", "An error occurred while sending the verification. Please try again.");
                }
            });
        }
    }
    AresFunc.EmpPersonalContactEdit = EmpPersonalContactEdit;
})(AresFunc || (AresFunc = {}));
var empPersonalContactEdit = new AresFunc.EmpPersonalContactEdit();

// ===== wwwroot/js/site.js =====
//===========================================================================
function initApp() {
    window.windowTitlePrefix = "<span id='image_loading_win1' class='progressIndWin'><\/span><span class='site-brand-win'>ARES</span><span class='site-win-title'>Online</span> - ";
    window.calledResize = false;
    window.resizeTimer = null;

    $(document).ajaxSend(function (e, xhr, options) {
        if (!options.headers) {
            options.headers = {};
        }
        options.headers["RequestVerificationToken"] = $("input[name=__RequestVerificationToken]").val();
        progressManager.show();
        progressManager.resetAfterDelay(); // Safety timeout
    });

    $(document).ajaxComplete(function () {
        progressManager.hide();
    });

    $(document).ajaxError(function (event, jqXHR, ajaxSettings, thrownError) {
        progressManager.hide();
        
        if (jqXHR.status === 0) {
            // This is a network error, do not log it
            return;
        }

        appFunc.logJavaScriptError(thrownError + " | Status: " + jqXHR.status +
            " | Event: " + event + " Settings: " + ajaxSettings.url +
            " | Message: " + thrownError + " | " + jqXHR.responseText, true);

        if (jqXHR.status === 403) {
            kendoWin.openInfoWin("An error occurred", "403 - Forbidden");
        }
    });

    window.addEventListener("error", function (event) {
        setTimeout(function () {
            progressManager.forceHide();
        }, 200);
    });


    window.onbeforeunload = function () {
        $("#logoutForm").submit();
    };

    setTimeout(function () {
        $(window).bind("resize", function () {
            appFunc.windowResized();
            clearTimeout(window.resizeTimer);
            window.resizeTimer = setTimeout(appFunc.windowResized, 150);
        }).trigger("resize");
    }, 80);

    $("#supportsPlaceholder").val(supportsPlaceholder());


   // Idle Timeout ===========================================================================
    //var inactiveTimeout = 60000 * (($("#SessionTimeoutMinutes").val() * 1) - 1);
    var inactiveTimeout = 60000 * 8; // 8 Minutes

    (function ($) {
        var session = {
            //Logout Settings

            //inactiveTimeout: 10000,     //(ms) The time until we display a warning message
            warningTimeout: 30000,      //(ms) The time until we log them out
            minWarning: 5000,           //(ms) If they come back to page (on mobile), The minumum amount, before we just log them out
            warningStart: null,         //Date time the warning was started
            warningTimer: null,         //Timer running every second to countdown to logout
            logout: function () {       //Logout function once warningTimeout has expired
                clearTimeout(session.warningTimer);
                $.idleTimer("destroy");
                navigate.logOffPage();
            }
        }

        $(document).on("idle.idleTimer", function (event, elem, obj) {

            //Get time when user was last active
            var diff = (+new Date()) - obj.lastActive - obj.timeout,
                warning = (+new Date()) - diff;

            //On mobile js is paused, so see if this was triggered while we were sleeping. A sleep that outlasted
            //the warning (a closed laptop, a locked phone) signs the member out at once: the countdown below
            //would never run for them.
            if (diff >= session.warningTimeout || warning <= session.minWarning) {
                session.logout();
            } else {
                //Show dialog, and note the time
                $("#sessionSecondsRemaining").html(Math.round((session.warningTimeout - diff) / 1000));
                //$("#myModal").modal("show");
                $("#SessionTimeoutWindow").data("kendoWindow").center().open();
                session.warningStart = (+new Date()) - diff;

                //Update counter downer every second
                session.warningTimer = setInterval(function () {
                    var remaining = Math.round((session.warningTimeout / 1000) - (((+new Date()) - session.warningStart) / 1000));
                    if (remaining >= 0) {
                        $("#sessionSecondsRemaining").html(remaining);
                    } else {
                        session.logout();
                    }
                }, 1000);
            }
        });

        //User clicked ok to extend session
        $("#btnSessionKeep").click(function () {
            $("#SessionTimeoutWindow").data("kendoWindow").close();
            clearTimeout(session.warningTimer);
        });
        //User clicked logout
        $("#btnSessionLogout").click(function () {
            session.logout();
        });

    })(jQuery);

    if ($("#hidIsAuthenticated").val() === "1") {
        $(document).idleTimer(inactiveTimeout);
    }

}

//===========================================================================
function supportsPlaceholder() {
    return typeof $("<input>")[0].placeholder == "string" ? 1 : 0;
}


//===========================================================================
function setFocus(elementId) {

    if (!elementId) return;

    if (elementId.charAt(0) !== "#") elementId = "#" + elementId;

    if ($(elementId).length) {
        setTimeout(function () {
            $(elementId).focus();
        }, 100);
    }
}
//===========================================================================





